var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayExtraBoldItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:07:44 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-ExtraBoldItalic",
    horizAdvX: 591
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway ExtraBold",
    fontWeight: 800,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 9 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 525,
    capHeight: 710,
    bbox: "-233 -231 1339 930",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+000D-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 645,
    d: "M98 361h-63l26 121h63l4 17q10 45 30.5 83t49.5 65t65 42.5t78 15.5q31 0 61.5 -7.5t62.5 -21.5q30 29 67.5 46.5t82.5 17.5q33 0 63 -9t61 -22l-55 -120q-13 6 -29.5 11t-33.5 5q-29 0 -47 -21t-25 -53l-10 -49h117l-25 -121h-118l-77 -361h-160l77 361h-105l-76 -361 h-160zM389 482q4 18 9 38.5t10 37.5q-12 6 -26.5 9t-26.5 3q-28 0 -44 -18t-22 -48l-5 -22h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 577,
    d: "M98 361h-63l26 121h63l9 43q10 46 34 85.5t58.5 68.5t78.5 45t93 16q54 0 99 -19t90 -53l-87 -121q-24 26 -55.5 42t-64.5 16q-34 0 -56 -21t-29 -53l-11 -49h279l-103 -482h-160l76 361h-117l-76 -361h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 661,
    d: "M462 -8q-59 0 -89.5 27t-30.5 68q0 7 1 14t3 15l82 381q3 16 5 30t2 25q0 24 -11 38.5t-40 14.5q-42 0 -64 -27.5t-31 -72.5l-5 -23h72l-25 -121h-73l-76 -361h-160l76 361h-63l26 121h63l13 58q11 50 35 87.5t59 62.5t79.5 37.5t95.5 12.5q102 0 148.5 -41t46.5 -112 q0 -14 -1.5 -28.5t-5.5 -30.5l-71 -336q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -15 7 -27t25 -12q8 0 18 2.5t19 5t15 5t7 2.5l-8 -129q-2 -1 -15 -5.5t-33 -9.5t-45 -9t-49 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 843,
    d: "M98 361h-63l26 121h63l4 17q10 44 30.5 82t49.5 65.5t65 43t78 15.5q31 0 61.5 -7.5t62.5 -21.5q35 29 82 46.5t102 17.5q49 0 96.5 -18.5t95.5 -53.5l-87 -121q-23 26 -55 42t-61 16q-38 0 -60 -21t-29 -53l-10 -49h278l-103 -482h-160l77 361h-118l-77 -361h-160 l77 361h-105l-76 -361h-160zM389 482q4 18 9 38.5t10 37.5q-12 6 -26.5 9t-26.5 3q-28 0 -43.5 -18t-22.5 -48l-5 -22h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 925,
    d: "M727 -8q-60 0 -90 27t-30 68q0 14 4 31l82 386q3 12 5 23.5t2 22.5q0 24 -12 39.5t-44 15.5q-20 0 -34.5 -8t-26 -22t-19 -32.5t-11.5 -39.5l-4 -21h72l-26 -121h-72l-77 -361h-160l77 361h-105l-76 -361h-160l76 361h-63l26 121h63l4 17q10 45 31 83t50 65t64.5 42.5 t76.5 15.5q32 0 63 -7.5t63 -21.5q36 32 86 48t109 16q102 0 148 -41t46 -112q0 -28 -6 -59l-72 -336q-2 -10 -2 -18q0 -16 7 -28t26 -12q8 0 18 2.5t18.5 5t15 5l6.5 2.5l-8 -129q-1 -1 -14.5 -5.5t-33.5 -9.5t-44.5 -9t-48.5 -4zM389 482q4 19 8.5 39.5t9.5 37.5 q-12 6 -25.5 8.5t-24.5 2.5q-27 0 -45 -18t-23 -47l-5 -23h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 230
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 309,
    d: "M71 282l91 435h160l-91 -435h-160zM10 0l36 166h160l-36 -166h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 427,
    d: "M96 498l49 228h135l-49 -228h-135zM276 498l49 228h135l-49 -228h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 708,
    d: "M696 412h-146l-47 -114h122l-25 -119h-151l-79 -179h-128l80 179h-79l-78 -179h-128l79 179h-106l25 119h135l48 114h-112l24 110h139l83 188h128l-84 -188h79l82 188h128l-84 -188h119zM376 298l47 114h-78l-48 -114h79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 620,
    d: "M529 502q-2 3 -13.5 12.5t-30 20t-42.5 20t-51 13.5l-28 -135l30 -9q38 -12 69.5 -26.5t53.5 -34.5t34 -47t12 -64q0 -67 -24 -115t-64 -79t-90.5 -46.5t-102.5 -18.5l-24 -116h-70l25 117q-64 6 -123.5 28.5t-103.5 57.5l102 143q2 -5 16 -16.5t36.5 -24t52.5 -24 t63 -16.5l28 131l-46 16q-72 26 -107.5 61t-35.5 94q0 60 22.5 107.5t60 82t86.5 55t103 25.5l21 101h68l-21 -101q60 -6 109.5 -29t84.5 -47zM379 203q0 19 -14.5 31.5t-38.5 22.5l-25 -117q42 2 60 19.5t18 43.5zM275 500q0 -18 12 -29.5t35 -21.5l25 120 q-35 -3 -53.5 -21.5t-18.5 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 790,
    d: "M223 411q-30 0 -55 10t-43 27.5t-27.5 41t-9.5 50.5q0 36 17 69t44.5 57.5t63.5 39t75 14.5q30 0 55 -10t43 -27.5t27.5 -41t9.5 -50.5q0 -36 -17 -69t-44.5 -57.5t-63.5 -39t-75 -14.5zM239 489q13 0 26 8t23.5 21t17 30t6.5 36q0 25 -11 41.5t-29 16.5q-13 0 -26 -8 t-23.5 -21t-17 -30t-6.5 -36q0 -24 11 -41t29 -17zM525 -10q-30 0 -55 10t-43 27.5t-27.5 41t-9.5 50.5q0 36 17 69t44.5 57.5t64 39t75.5 14.5q30 0 54.5 -10t42.5 -27.5t27.5 -41t9.5 -50.5q0 -36 -16.5 -69t-44.5 -57.5t-64 -39t-75 -14.5zM542 68q13 0 25.5 8t23 21 t17 30t6.5 36q0 24 -11 41t-29 17q-13 0 -26 -8t-23.5 -21t-17 -30t-6.5 -36q0 -25 11 -41.5t30 -16.5zM52 56l338 324l313 339l58 -64l-326 -315l-325 -349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 712,
    d: "M395 52q-48 -31 -97 -46.5t-96 -15.5t-82.5 15t-59 39.5t-35.5 57t-12 68.5q0 37 12.5 68t34.5 57.5t50.5 48.5t61.5 42q-23 38 -34 67.5t-11 61.5q0 45 19 82.5t51 64.5t73 42t86 15q63 0 112.5 -34t66.5 -106l-112 -51q-10 38 -32 56.5t-47 18.5t-46 -17t-21 -44 q0 -10 3.5 -19.5t11.5 -22t19.5 -29t28.5 -40.5l111 -162q17 32 29 68.5t18 78.5h184l-15 -111h-71q-16 -38 -35 -72t-41 -63l118 -170h-207zM246 112q22 0 45 7t46 21l-97 144q-38 -23 -54.5 -46t-16.5 -52q0 -37 22.5 -55.5t54.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 247,
    d: "M96 497l49 229h135l-49 -229h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 319,
    d: "M31 265q0 65 19 126.5t52 122t77.5 122.5t95.5 128l111 -50q-47 -60 -84.5 -119t-64.5 -114.5t-41.5 -108t-14.5 -99.5q0 -63 13.5 -134.5t36.5 -140.5l-130 -57q-15 35 -27.5 74.5t-22 81.5t-15 84.5t-5.5 83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 318,
    d: "M308 431q0 -68 -20.5 -132t-54.5 -125t-78 -119.5t-91 -113.5l-104 57q42 57 78 109t62.5 104t41.5 104.5t15 109.5q0 43 -5.5 87t-13 83.5t-16 70.5t-14.5 48l133 50q28 -82 47.5 -168.5t19.5 -164.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 346,
    d: "M114 510l61 75l-63 21l35 67l63 -34l11 80h82l-22 -80l77 34l6 -67l-73 -21l31 -75l-68 -39l-28 79l-61 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 433,
    d: "M393 419v-128h-95v-104h-144v104h-94v128h94v104h144v-104h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 242,
    d: "M-20 -135l60 137h-49l34 161h135l-35 -161l-75 -137h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 400,
    d: "M32 203l31 144h294l-31 -144h-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 238,
    d: "M-9 0l34 163h131l-35 -163h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 729,
    d: "M782 710l-633 -710h-176l633 710h176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 595,
    d: "M231 -10q-45 0 -80.5 17.5t-61 48.5t-39 74.5t-13.5 94.5q0 77 27 145t72 118.5t103.5 79.5t121.5 29q44 0 80 -17.5t61 -49t38.5 -74.5t13.5 -95q0 -77 -27 -145t-71.5 -118t-103 -79t-121.5 -29zM262 137q25 0 48 16.5t41 45t28.5 66t10.5 79.5q0 48 -15.5 77t-44.5 29 q-26 0 -50 -17t-42 -45.5t-28.5 -66.5t-10.5 -79q0 -48 16.5 -76.5t46.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 503,
    d: "M28 144h135l55 255q-11 -12 -32 -24.5t-45 -23t-49 -17t-43 -6.5l31 148q15 0 41.5 11t53.5 26.5t49.5 31.5t29.5 26h163l-90 -427h121l-31 -144h-419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 563,
    d: "M-28 0q10 47 25 84.5t38.5 68.5t57 56.5t80.5 48.5q53 26 88 43.5t55.5 32t29 28t8.5 30.5q0 23 -14.5 36.5t-43.5 13.5q-36 0 -70 -20.5t-69 -53.5l-76 118q20 18 49.5 35t65.5 30.5t76 21.5t82 8q91 0 137 -38t46 -103q0 -40 -12.5 -70t-33.5 -54t-48 -43t-56 -36 q-31 -17 -68 -40.5t-65 -52.5h232l-30 -144h-484v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 549,
    d: "M156 -147q-143 0 -208 89l109 114q20 -28 48.5 -42.5t73.5 -14.5q65 0 94.5 26.5t29.5 75.5q0 35 -27 53.5t-86 18.5h-28l24 115h32q57 0 93 27.5t36 70.5q0 26 -16.5 39.5t-45.5 13.5q-37 0 -72.5 -19.5t-65.5 -55.5l-76 116q21 21 50 39t63.5 30.5t72 19.5t75.5 7 q91 0 143 -40.5t52 -106.5q0 -34 -13 -66t-35 -58t-51.5 -44t-61.5 -24q47 -9 73.5 -48t26.5 -94q0 -54 -22.5 -99t-63.5 -76.5t-98 -49t-126 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 561,
    d: "M218 10h-257l31 143l396 418h110l-89 -417h84l-31 -144h-84l-29 -137h-160zM267 154l38 177l-154 -177h116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 536,
    d: "M153 -149q-74 0 -126 31t-72 87l110 99q19 -35 51 -56t68 -21q24 0 45 9t36.5 25t24.5 38.5t9 48.5q0 33 -17.5 53t-47.5 20q-25 0 -48 -12t-39 -34h-138q18 42 40.5 100.5t46.5 119t46 117t38 95.5h336l-31 -146h-220l-43 -121q6 7 22 12.5t42 5.5q42 0 75.5 -13.5 t57 -37.5t36 -57.5t12.5 -74.5q0 -62 -24.5 -115t-67.5 -91.5t-100 -60t-122 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 592,
    d: "M235 -10q-94 0 -144 63.5t-50 175.5q0 101 26.5 190t75 155t115.5 104t148 38q63 0 110.5 -27t79.5 -78l-112 -102q-17 32 -46 50t-64 18q-54 0 -94 -42t-58 -119q25 27 58 42t72 15q43 0 78.5 -14.5t61 -40t39 -61t13.5 -76.5q0 -59 -25.5 -112t-68.5 -92.5t-98.5 -63 t-116.5 -23.5zM264 125q22 0 44.5 11t40 29.5t28.5 43t11 50.5q0 38 -21 63t-56 25q-23 0 -45.5 -10.5t-39.5 -28.5t-27.5 -41.5t-10.5 -49.5q0 -38 21 -65t55 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 563,
    d: "M335 438h-277l31 146h529l-483 -710h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 587,
    d: "M226 -9q-44 0 -82 13.5t-66 38.5t-43.5 60t-15.5 78q0 38 12.5 69.5t31.5 56t42 42.5t44 30q-22 14 -34.5 42.5t-12.5 60.5q0 54 27 96.5t68.5 71.5t90 44.5t91.5 15.5q35 0 69.5 -11t62.5 -32.5t45 -53t17 -73.5q0 -26 -9 -51t-23.5 -46t-33.5 -37.5t-38 -26.5 q23 -18 41.5 -52t18.5 -79q0 -56 -25.5 -103t-67.5 -81.5t-97 -53.5t-113 -19zM257 136q21 0 41 8.5t35 22.5t24.5 33.5t9.5 42.5q0 34 -20.5 52t-51.5 18q-21 0 -41 -8t-35 -22t-24 -33t-9 -42q0 -32 20.5 -52t50.5 -20zM320 433q14 0 29.5 5.5t28 16t21 25.5t8.5 35 q0 24 -16 39t-42 15q-17 0 -32 -6t-27 -17t-19 -26t-7 -32q0 -27 17.5 -41t38.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 574,
    d: "M169 -155q-63 0 -111 27t-80 78l112 102q17 -32 46 -50t65 -18q53 0 93 42t59 119q-26 -27 -59 -42t-71 -15q-44 0 -79.5 14.5t-60.5 40t-38.5 61t-13.5 76.5q0 59 25.5 112t68 92.5t98 63t116.5 23.5q94 0 144 -63.5t50 -175.5q0 -101 -26.5 -190t-74.5 -155t-115 -104 t-148 -38zM263 214q23 0 45 10.5t39.5 28.5t28 41.5t10.5 49.5q0 38 -21 65t-55 27q-22 0 -44 -11t-40 -29.5t-29 -43t-11 -50.5q0 -38 21 -63t56 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 269,
    d: "M81 356l35 163h130l-35 -163h-130zM6 0l34 163h131l-35 -163h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 272,
    d: "M82 356l34 163h131l-35 -163h-130zM-6 -135l60 137h-49l35 161h134l-35 -161l-75 -137h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 552,
    d: "M29 293l422 256v-170l-190 -120l190 -113v-179l-422 250v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 488,
    d: "M79 124v102h318v-102h-318zM79 326v102h318v-102h-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 552,
    d: "M504 217l-422 -250v179l190 113l-190 120v170l422 -256v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 476,
    d: "M92 245q4 23 11 44t19 40.5t30.5 36.5t47.5 31q34 17 61 32t46 31t29.5 33.5t10.5 40.5q0 26 -16.5 41t-40.5 15q-18 0 -33.5 -7.5t-28.5 -18t-24 -23.5t-19 -23l-88 72q38 61 98.5 95t128.5 34q31 0 61.5 -9t53.5 -28t37.5 -49t14.5 -72t-10 -73.5t-27 -55.5t-40 -42 t-50 -34q-23 -14 -46 -25t-43 -23t-34 -27t-18 -36h-131zM42 0l32 150h131l-32 -150h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 816,
    d: "M582 53q24 0 45.5 22.5t37 58t25 78t9.5 82.5q0 54 -17 99.5t-49 78.5t-78.5 51.5t-104.5 18.5q-74 0 -140.5 -29.5t-116.5 -80.5t-79.5 -120t-29.5 -148q0 -57 15.5 -103t45 -78.5t72 -50t95.5 -17.5q38 0 73.5 9t79.5 29l7 -59q-88 -40 -173 -40q-64 0 -116 21.5 t-88.5 61t-56.5 95t-20 124.5q0 95 37 177t98.5 142t142.5 94t170 34q69 0 124 -21t93.5 -59.5t59.5 -92t21 -118.5q0 -54 -14.5 -112t-42 -106t-67 -79t-88.5 -31q-35 0 -56.5 16.5t-21.5 48.5q0 11 2 15q-78 -69 -156 -69q-37 0 -67 13.5t-51 38t-32 58.5t-11 74 q0 57 21 108.5t56 91t80.5 63t94.5 23.5q48 0 79.5 -22.5t40.5 -57.5l12 65h75l-64 -326q-2 -8 -3 -17t-1 -16q0 -38 32 -38zM352 72q42 0 73 26t49 69l19 122q-7 38 -30.5 62.5t-58.5 24.5q-27 0 -54 -14.5t-48.5 -39.5t-35 -59t-13.5 -73q0 -50 24.5 -84t74.5 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 661,
    d: "M155 710h379q30 0 52.5 -12.5t37.5 -32.5t22.5 -46.5t7.5 -54.5q0 -30 -9.5 -60t-27 -56.5t-43 -48.5t-57.5 -35q45 -14 69 -50t24 -90q0 -57 -23 -99t-61 -69.5t-88.5 -41.5t-104.5 -14h-329zM363 139q16 0 31.5 7t27.5 20t19 30t7 38q0 26 -12.5 43t-33.5 17h-172 l-32 -155h165zM403 423q14 0 28.5 6t26 17.5t18.5 29t7 40.5q0 26 -12 40t-31 14h-151l-31 -147h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 661,
    d: "M297 -6q-63 0 -112 25.5t-83 68t-51.5 97t-17.5 112.5q0 49 14.5 99t41 96.5t64.5 86.5t85 70t102 47.5t116 17.5q96 0 157 -43t81 -112l-145 -88q-5 28 -17.5 46.5t-30.5 30t-39 16t-41 4.5q-52 0 -93 -24.5t-69.5 -63t-43.5 -84.5t-15 -89q0 -34 8.5 -64t25 -53 t41.5 -36.5t57 -13.5q21 0 43.5 5.5t45 17t43 30t35.5 45.5l118 -79q-24 -39 -61 -70t-80.5 -52t-90 -32t-88.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 693,
    d: "M155 710h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254zM288 144q50 0 91 21.5t70.5 58.5t45.5 85t16 101q0 70 -33.5 113t-99.5 43h-90l-90 -422h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 552,
    d: "M155 710h458l-30 -144h-295l-32 -153h242l-28 -133h-243l-59 -280h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 704,
    d: "M481 70q-48 -38 -93.5 -56.5t-96.5 -18.5q-57 0 -104 21t-81.5 59t-53.5 91.5t-19 118.5q0 88 35.5 166.5t95 137t136 92.5t158.5 34q93 0 155.5 -41.5t82.5 -113.5l-141 -92q-13 48 -49.5 74.5t-84.5 26.5q-44 0 -83.5 -21.5t-69.5 -58t-48 -84.5t-18 -101q0 -35 9 -65 t26.5 -52t42 -34t56.5 -12q89 0 179 88l5 23h-129l25 119h265l-79 -371h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 721,
    d: "M155 710h164l-59 -275h257l59 275h164l-151 -710h-164l62 291h-257l-62 -291h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 483,
    d: "M92 -11q-85 0 -137 44l63 134q7 -8 35.5 -20t69.5 -12q33 0 55.5 12.5t38.5 38.5t28 66.5t24 96.5l77 361h165l-77 -361q-17 -81 -39.5 -147.5t-60 -113.5t-96 -73t-146.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 653,
    d: "M155 710h164l-65 -306l300 306h185l-319 -317l184 -393h-188l-123 286l-81 -77l-44 -209h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 563,
    d: "M155 710h164l-121 -566h321l-30 -144h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 825,
    d: "M155 710h178l88 -371l246 371h178l-151 -710h-165l91 425l-203 -309h-88l-70 309l-91 -425h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 729,
    d: "M155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 733,
    d: "M301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92 q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 602,
    d: "M155 710h289q41 0 74 -17t55.5 -45t34.5 -64t12 -74q0 -51 -22 -101.5t-59.5 -90t-87 -64.5t-105.5 -25h-130l-48 -229h-164zM366 372q15 0 30.5 8.5t28 25t20 39t7.5 51.5q0 36 -15 53t-35 17h-114l-41 -194h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 732,
    d: "M472 36q-40 -20 -83.5 -30.5t-88.5 -10.5q-65 0 -114.5 24.5t-84 65.5t-52 94.5t-17.5 111.5q0 81 35 157t93.5 135.5t135 95.5t160.5 36q65 0 114.5 -25t83.5 -66.5t51 -95.5t17 -111q0 -86 -39 -166.5t-105 -140.5l74 -110h-155zM333 141q32 0 63 11l-85 128h153 l33 -50q28 38 43 84.5t15 91.5q0 33 -8 62.5t-24.5 52t-41 35.5t-58.5 13q-51 0 -92.5 -24.5t-70.5 -63t-44.5 -85.5t-15.5 -92q0 -32 8 -61.5t24.5 -52t41.5 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 647,
    d: "M4 0l151 710h305q42 0 74.5 -17t55 -45t34.5 -64t12 -74q0 -37 -11.5 -73t-32 -68.5t-49 -59.5t-62.5 -45l91 -264h-185l-78 229h-93l-48 -229h-164zM383 372q15 0 30 9.5t27 26t19.5 38.5t7.5 47q0 33 -14 53t-34 20h-131l-41 -194h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 594,
    d: "M244 -8q-75 0 -147 23t-124 65l102 143q2 -5 19.5 -19t45 -28t63.5 -25t75 -11q48 0 68 17.5t20 45.5q0 17 -11 28.5t-30.5 21t-45 18t-54.5 18.5q-72 26 -107.5 61t-35.5 94q0 64 26 115t68.5 85.5t97.5 53t113 18.5q36 0 69 -7t62 -18t53.5 -25t44.5 -28l-100 -136 q-2 4 -16.5 15t-37.5 23t-52 21t-59 9q-42 0 -65.5 -18.5t-23.5 -51.5q0 -29 31 -43.5t88 -32.5q38 -12 69.5 -26.5t54 -34.5t34.5 -47t12 -64q0 -71 -27 -120.5t-71 -80.5t-99 -45t-110 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 596,
    d: "M273 566h-203l30 144h569l-30 -144h-202l-121 -566h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 717,
    d: "M293 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5 t-140.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 644,
    d: "M82 710h173l44 -504l257 504h172l-404 -710h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1002,
    d: "M76 710h178l52 -522l102 191l-40 330h150l18 -227l114 227h151l-183 -330l23 -191l273 522h180l-420 -710h-136l-46 278l-162 -278h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 625,
    d: "M236 350l-155 360h178l89 -245l192 245h177l-308 -360l149 -350h-177l-83 235l-182 -235h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 623,
    d: "M213 244l-136 466h178l69 -326l211 326h178l-338 -468l-51 -242h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 595,
    d: "M-10 123l435 443h-327l30 144h518l-27 -123l-419 -443h329l-30 -144h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 322,
    d: "M-4 -40l166 780h211l-27 -127h-64l-111 -526h63l-26 -127h-212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 632,
    d: "M284 710l262 -710h-176l-263 710h177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 323,
    d: "M-30 -40l27 127h65l111 526h-64l27 127h211l-165 -780h-212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 608,
    d: "M46 303l198 407h133l197 -407h-130l-133 275l-137 -275h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 441,
    d: "M-44 -144l30 144h340l-30 -144h-340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 260,
    d: "M53 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 619,
    d: "M293 -10q-57 0 -94 25.5t-51 71.5l-18 -87h-140l155 730h160l-62 -291q32 44 79 70t99 26q41 0 73 -16.5t53.5 -45t32.5 -67t11 -83.5q0 -69 -25 -129.5t-66 -106t-95 -71.5t-112 -26zM279 125q28 0 54 13.5t46 36t32 52.5t12 64q0 45 -21.5 76.5t-59.5 31.5 q-34 0 -68.5 -26t-57.5 -65l-24 -110q10 -34 31.5 -53.5t55.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 548,
    d: "M230 -10q-55 0 -96 17.5t-68.5 48t-41 70.5t-13.5 85q0 61 24.5 119.5t68.5 104t105.5 73t135.5 27.5q88 0 139 -38.5t68 -100.5l-165 -47q-19 50 -72 50q-26 0 -51 -13t-44.5 -35.5t-31 -53.5t-11.5 -68q0 -47 22 -75.5t58 -28.5q26 0 51.5 14.5t41.5 37.5l146 -48 q-42 -61 -110 -100t-156 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l62 291h161l-118 -550q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-38 0 -62 15t-24 49q0 12 4 31 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 558,
    d: "M232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10 zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 376,
    d: "M98 361h-63l26 121h63l9 43q10 49 31 89t50.5 68t65.5 43t76 15q61 0 126 -31l-55 -120q-13 7 -31 11.5t-33 4.5q-54 0 -69 -74l-11 -49h115l-26 -121h-114l-122 -574h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 618,
    d: "M160 -223q-81 0 -133 27t-84 78l104 87q20 -33 56.5 -52.5t81.5 -19.5q27 0 53 8t48 24.5t38 43t24 63.5l10 51q-31 -44 -78.5 -66.5t-96.5 -22.5q-41 0 -72.5 16t-53.5 44t-33.5 65.5t-11.5 81.5q0 67 24 127t65 105t95 71.5t114 26.5q55 0 91.5 -25.5t52.5 -70.5l19 86 h139l-104 -489q-13 -60 -44.5 -108t-77 -81.5t-103.5 -51.5t-123 -18zM267 125q32 0 62 20.5t53 52.5l24 110q-6 42 -31 66.5t-57 24.5q-27 0 -52.5 -15t-44.5 -39t-30.5 -54.5t-11.5 -61.5q0 -45 23.5 -74.5t64.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M145 730h160l-62 -293q37 47 87 72.5t105 25.5q36 0 59.5 -10t38 -26.5t20 -38.5t5.5 -46q0 -19 -2.5 -38.5t-6.5 -39.5l-71 -336h-160l63 295q2 11 3 20.5t1 18.5q0 31 -14 45.5t-38 14.5q-12 0 -28 -6.5t-32.5 -19t-32 -29.5t-26.5 -38l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525h-160zM145 730h160l-31 -145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 273,
    d: "M-75 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q20 0 37 14.5t22 40.5l113 534h160l-110 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15zM150 730h160l-31 -145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 570,
    d: "M145 730h159l-71 -336q40 64 91.5 100.5t111.5 36.5q55 0 83.5 -31t28.5 -87q0 -66 -36.5 -122t-105.5 -93l89 -198h-170l-88 227q79 15 123 48.5t44 74.5q0 22 -12 33.5t-32 11.5q-21 0 -44 -12.5t-45 -33.5t-40.5 -49.5t-30.5 -60.5l-51 -239h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 326,
    d: "M126 -9q-57 0 -86 25t-29 73q0 10 1.5 20t3.5 22l127 599h160l-116 -543q-1 -5 -1.5 -10.5t-0.5 -10.5q0 -39 38 -39q11 0 25.5 3.5t27.5 10.5l-5 -120q-32 -14 -72 -22t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 897,
    d: "M102 525h144l-19 -88q36 47 90 72.5t111 25.5q32 0 54 -8t36 -21.5t20.5 -32t8.5 -40.5q39 49 91 75.5t109 26.5q34 0 57 -10t36.5 -26.5t19 -38t5.5 -45.5q0 -12 -2 -31.5t-8 -47.5l-72 -336h-160l63 295q2 12 3.5 22.5t1.5 19.5q0 29 -12 43t-32 14q-15 0 -31 -7 t-31.5 -19.5t-30 -29.5t-24.5 -37l-63 -301h-160l63 295q2 12 3.5 22.5t1.5 19.5q0 29 -12.5 43t-32.5 14q-29 0 -62 -26.5t-54 -66.5l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    d: "M229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67 q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 618,
    d: "M101 525h140l-19 -85q37 45 83 70t103 25q42 0 76 -16.5t57.5 -45t36 -68t12.5 -84.5q0 -66 -23 -126t-62 -105.5t-90 -72.5t-106 -27q-56 0 -92 25t-49 70l-64 -298h-160zM283 125q27 0 52 14.5t44.5 38.5t31.5 54.5t12 62.5q0 45 -24 74.5t-66 29.5q-29 0 -60 -19.5 t-54 -52.5l-23 -108q7 -40 30.5 -67t56.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 618,
    d: "M176 -10q-39 0 -69.5 16t-51.5 44.5t-32.5 67t-11.5 83.5q0 69 25 130t66 106t95 71.5t112 26.5q57 0 92.5 -26t52.5 -70l18 86h140l-117 -550q-3 -11 -3 -18q0 -25 34 -26l-29 -136q-22 -4 -46 -6t-42 -2q-42 0 -68.5 21.5t-26.5 59.5q0 11 3 22l41 195 q-34 -47 -80.5 -71t-101.5 -24zM267 125q31 0 60 19.5t55 51.5l24 111q-5 39 -29.5 65.5t-57.5 26.5q-27 0 -52.5 -14.5t-45 -38t-31.5 -54t-12 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 392,
    d: "M102 525h147l-23 -106q38 53 84.5 83t91.5 30q19 0 23 -1l-30 -143q-54 -1 -101.5 -19t-76.5 -54l-67 -315h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 482,
    d: "M187 -10q-63 0 -120.5 21.5t-92.5 62.5l77 98q38 -33 78 -51t79 -18q32 0 48 13.5t16 36.5q0 17 -16.5 28.5t-57.5 24.5t-70.5 25.5t-48.5 27t-28 32t-9 40.5q0 44 19.5 81.5t52.5 64.5t77 42.5t94 15.5q56 0 101.5 -16t83.5 -58l-82 -96q-37 31 -67 45t-60 14 q-27 0 -45 -13t-18 -39q0 -17 17 -27.5t56 -21.5q86 -25 124 -54t38 -79q0 -44 -18 -81t-50.5 -63.5t-77.5 -41t-100 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 392,
    d: "M163 -10q-51 0 -84 22.5t-33 76.5q0 21 4 41l58 274h-63l27 121h62l36 167h160l-36 -167h101l-26 -121h-101l-46 -219q-1 -5 -1.5 -9t-0.5 -8q0 -17 9.5 -24.5t24.5 -7.5q16 0 36 6t37 13v-127q-36 -16 -79 -27t-85 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5 q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 536,
    d: "M47 525h166l17 -397q33 55 59.5 103.5t48 95t39.5 94.5t36 104h145q-36 -131 -108.5 -262.5t-174.5 -262.5h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 802,
    d: "M38 525h154l51 -380q5 6 15 24.5t21.5 39.5t21 39.5t13.5 24.5l-48 252h133l18 -159q3 6 14 29.5t23.5 50t22.5 50t12 29.5h123q-27 -72 -56.5 -131t-71.5 -120l17 -93q40 53 68 93.5t49.5 78t40 78t39.5 94.5h145q-49 -131 -133.5 -262.5t-199.5 -262.5h-105l-25 184 q-3 -4 -11 -18t-18.5 -33t-23 -41t-23.5 -41t-19 -33.5t-11 -17.5h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 522,
    d: "M166 262l-114 263h162l54 -148l5 -19l12 19l120 148h161l-227 -263l119 -262h-163l-58 147l-5 19l-12 -19l-120 -147h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 531,
    d: "M-50 -111q30 1 51 4.5t37 10.5t29 18.5t27 29.5l29 37l-78 536h163l29 -388l34 56q51 82 82 161.5t51 170.5h154q-14 -48 -29 -90t-38 -89.5t-56.5 -105t-82.5 -137.5l-80 -129q-35 -57 -69 -96t-70 -63t-76 -35t-88 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 471,
    d: "M-19 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 332,
    d: "M301 613l-38 -181q-5 -23 -19.5 -40.5t-32.5 -31.5q9 -11 16 -24.5t7 -30.5q0 -7 -2 -17l-40 -192h52l-27 -127h-174q-5 0 -11 4t-6 16q0 6 1 10l50 235q1 5 1.5 8.5t0.5 7.5q0 23 -12 37.5t-28 18.5l23 110q10 0 21 6.5t21 16.5t17 22.5t10 24.5l47 224q4 18 14 24t15 6 h174l-28 -127h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 342,
    d: "M108 -130v905h135v-905h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 335,
    d: "M115 613l27 127h173q5 0 11 -4.5t6 -15.5q0 -6 -1 -10l-48 -224q-1 -4 -1.5 -7t-0.5 -7q0 -22 12 -39t29 -17l-24 -110q-20 -5 -41 -24t-27 -48l-50 -235q-4 -18 -13.5 -24t-15.5 -6h-173l27 127h52l41 192q5 23 19.5 40.5t31.5 31.5q-8 11 -15 24t-7 30v9t2 9l39 181 h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 565,
    d: "M37 222q0 10 8.5 34t27.5 49t48.5 43.5t72.5 18.5q28 0 51 -8.5t43 -18t40 -18t43 -8.5q21 0 35 7.5t22 16.5t11 17t3 10h86q0 -6 -9 -29.5t-28 -48.5t-49.5 -45t-75.5 -20q-27 0 -49.5 8t-43 17.5t-41 17.5t-42.5 8t-35 -7.5t-20 -17t-9 -17.5t-2 -9h-87v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 230
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 309,
    d: "M262 429l-93 -435h-160l93 435h160zM321 711l-35 -166h-160l35 166h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 584,
    d: "M178 -120l24 111q-42 3 -74.5 23t-55 50.5t-34.5 68.5t-12 79q0 54 19.5 107t57 96.5t91.5 75t123 42.5l24 112h69l-24 -112q64 -2 113.5 -36t69.5 -101l-166 -47q-5 19 -18.5 31t-27.5 14l-57 -265q20 6 38 18.5t29 29.5l146 -48q-23 -35 -55 -61t-65.5 -43.5t-66 -26 t-55.5 -8.5l-24 -110h-69zM192 225q0 -29 10.5 -53t30.5 -35l53 250q-20 -7 -37 -24t-30 -39.5t-20 -48t-7 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 544,
    d: "M75 384h59q-5 29 -10.5 58.5t-5.5 57.5q0 45 21 84t55.5 68.5t80 46t93.5 16.5q61 0 110.5 -27.5t77.5 -77.5l-102 -98q-17 32 -49.5 53t-64.5 21q-35 0 -58.5 -25t-23.5 -63q0 -25 7 -53.5t12 -60.5h179l-26 -119h-157q-11 -35 -35 -68t-69 -74q24 8 42 11t35 3 q32 0 61 -8t61 -8q17 0 32 3.5t35 10.5l14 -118q-25 -14 -57.5 -23t-60.5 -9q-22 0 -44 5t-44 10.5t-44.5 10.5t-46.5 5q-26 0 -63 -7t-73 -18l-9 114q47 32 80.5 73t46.5 87h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 580,
    d: "M194 501q22 12 48 19t57 7q30 0 55.5 -7t47.5 -18l69 70l62 -62l-66 -66q31 -47 31 -106q0 -61 -32 -108l67 -66l-57 -57l-72 67q-44 -25 -105 -25q-32 0 -58.5 7t-48.5 19l-72 -68l-57 57l67 68q-14 23 -22 50t-8 56q0 58 29 104l-66 68l62 62zM215 337q0 -41 24 -66 t60 -25t60 25t24 67t-24 66.5t-60 24.5t-60 -25t-24 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 700,
    d: "M540 416h64l-22 -103h-117l-51 -71l-7 -31h154l-21 -103h-155l-23 -108h-163l22 108h-152l22 103h153l7 33l-20 69h-118l22 103h66l-86 294h178l69 -326l210 326h179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 334,
    d: "M240 260v-390h-136v390h136zM240 775v-390h-136v390h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 524,
    d: "M438 223q5 -9 8.5 -24.5t3.5 -35.5q0 -69 -28 -117t-69.5 -77.5t-89 -43t-85.5 -13.5q-39 0 -71 12t-56 29t-40 35.5t-23 32.5l123 98q20 -30 43 -42.5t49 -12.5q29 0 51.5 16t22.5 45q0 20 -14 25t-30 7q-86 7 -127 47.5t-41 101.5q0 23 4 40t9.5 29.5t11 21t8.5 14.5 q-5 9 -10 29t-5 46q0 44 21 85t56 73t81 51.5t96 19.5q44 0 76 -14t53.5 -34.5t35.5 -44t22 -41.5l-135 -58q-8 22 -25 36t-46 14q-30 0 -50.5 -17t-20.5 -46q0 -22 14 -28.5t34 -7.5q32 -1 64 -9t58 -24.5t42 -43t16 -65.5q0 -19 -4.5 -36.5t-10.5 -32t-12 -25t-10 -15.5z M218 308q0 -17 9.5 -25t22 -11.5t26 -4.5t22.5 -5q9 7 15 19.5t6 24.5q0 23 -15 31.5t-30 8.5q-12 0 -23 2.5t-13 4.5q-8 -7 -14 -19t-6 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 497,
    d: "M73 593l28 129h132l-28 -129h-132zM278 593l28 129h131l-27 -129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 858,
    d: "M437 -7q-81 0 -150.5 27.5t-120 76t-79 114.5t-28.5 144q0 77 28.5 143t79 114t120 75.5t150.5 27.5q83 0 154 -27.5t122.5 -75.5t80.5 -114t29 -143q0 -78 -29 -144t-80.5 -114.5t-122.5 -76t-154 -27.5zM437 49q68 0 127.5 22.5t103 62.5t68.5 96t25 124 q0 64 -24.5 119.5t-68 97t-102.5 65t-129 23.5q-68 0 -125.5 -23.5t-100 -64.5t-66.5 -96.5t-24 -119.5t24 -120t66 -97t100 -65t126 -24zM446 114q-60 0 -108.5 19t-82 51.5t-51.5 76t-18 93.5q0 47 16.5 90.5t49 77t81 53.5t112.5 20q85 0 144.5 -37t88.5 -98l-155 -48 q-14 26 -35 37t-44 11q-42 0 -68 -30t-26 -76q0 -25 8 -44.5t21.5 -33t30.5 -20.5t35 -7q24 0 45.5 12.5t33.5 35.5l156 -47q-13 -28 -35 -53t-51.5 -43.5t-66.5 -29t-81 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 429,
    d: "M158 336q-42 0 -67.5 26.5t-25.5 67.5q0 31 13.5 57.5t36.5 45.5t54 30t66 11q44 0 68 -15l3 15q1 6 1.5 10.5t0.5 9.5q0 42 -50 42q-28 0 -54 -10t-58 -30l-18 71q75 47 157 47q66 0 100 -28t34 -82q0 -18 -5 -43l-18 -89q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-21 -97 q-29 -6 -51 -6q-31 0 -44.5 11.5t-13.5 34.5v7.5t1 10.5q-60 -65 -129 -65zM209 419q10 0 22 4t23 10.5t19 15t10 17.5l7 33q-10 6 -23.5 9t-24.5 3q-28 0 -48.5 -16.5t-20.5 -40.5q0 -15 10 -25t26 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 659,
    d: "M32 293l299 193l-27 -129l-154 -98l113 -91l-27 -129l-221 178zM343 293l299 193l-27 -129l-153 -98l113 -91l-27 -129l-221 178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 602,
    d: "M564 415l-67 -317h-135l37 173h-353l30 144h488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 595,
    d: "M32 203l31 144h488l-31 -144h-488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 858,
    d: "M439 -7q-83 0 -152.5 27.5t-120 76t-79 114.5t-28.5 144q0 77 28.5 143t79 114t120 75.5t152.5 27.5q82 0 152.5 -27.5t122 -75.5t80.5 -114t29 -143q0 -78 -29 -144t-80.5 -114.5t-122 -76t-152.5 -27.5zM439 48q67 0 125.5 23t101.5 63.5t67.5 96.5t24.5 122 q0 64 -24 120t-66.5 97t-101 65t-127.5 24t-127 -24t-99.5 -65t-65 -96.5t-23.5 -119.5t23.5 -119.5t65 -97t99.5 -65.5t127 -24zM273 574h197q31 0 57 -13t45 -34t29.5 -47.5t10.5 -53.5q0 -39 -20 -73.5t-52 -51.5l100 -161h-125l-87 140h-43v-140h-112v434zM459 376 q19 0 31 12t12 38q0 28 -14 39t-31 11h-72v-100h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 410,
    d: "M60 620l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 285,
    d: "M183 504q-40 0 -63 23t-23 61q0 26 10 50.5t28 43.5t42.5 30.5t53.5 11.5q40 0 63 -24.5t23 -62.5q0 -28 -10.5 -52.5t-28.5 -42.5t-42.5 -28t-52.5 -10zM200 579q14 0 27 12.5t13 29.5q0 14 -7.5 20.5t-18.5 6.5q-15 0 -28 -12t-13 -28q0 -12 7 -20.5t20 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 525,
    d: "M68 16v127h366v-127h-366zM435 445v-127h-111v-121h-144v121h-111v127h111v121h144v-121h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 414,
    d: "M46 383q9 42 21.5 73t32 55t48 42t68.5 34q27 10 52.5 20t46 21t33 25.5t12.5 35.5q0 20 -17.5 29t-47.5 9q-38 0 -71 -14.5t-54 -31.5l-44 68q12 12 31.5 24.5t45.5 22t57.5 16t67.5 6.5q69 0 104 -28.5t35 -81.5q0 -38 -14 -66t-36 -47.5t-49.5 -32t-54.5 -20.5 q-85 -26 -95 -68h187l-20 -91h-339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 399,
    d: "M203 376q-56 0 -90.5 19t-56.5 57l64 70q3 -5 8.5 -14t17 -17.5t30 -14.5t46.5 -6q18 0 35 3t30.5 9t22 15t8.5 21q0 25 -34 35t-97 10h-23l18 85h22q60 0 99 12t39 38q0 10 -6 16.5t-15 10.5t-20 5.5t-21 1.5q-37 0 -65 -13t-51 -34l-43 75q15 14 35.5 25t43.5 18.5 t47.5 11t47.5 3.5q69 0 109 -29t40 -75q0 -41 -32 -68t-81 -35q40 -7 60 -32.5t20 -60.5q0 -36 -19 -63t-49 -44.5t-67 -26t-73 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 259,
    d: "M125 586l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 650,
    d: "M113 525h160l-64 -301q-5 -25 -5 -40q0 -59 53 -59q24 0 54.5 17t61.5 59l68 324h160l-73 -345q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -14 7.5 -19.5t25.5 -6.5l-29 -135q-25 -5 -43 -6.5t-32 -1.5q-84 0 -84 64q0 2 0.5 13t2.5 22q-9 -15 -26 -32.5t-38.5 -32.5t-45.5 -25.5 t-46 -10.5q-28 0 -42.5 13t-16.5 35l-43 -251h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 657,
    d: "M61 387q0 73 23 133t66.5 102t104.5 65t138 23h307l-25 -119h-67l-143 -671h-135l59 279h-36l-59 -279h-136l60 279q-37 0 -66 13.5t-49.5 38.5t-31 59.5t-10.5 76.5zM195 399q0 -35 13.5 -57t34.5 -25l59 274q-21 -2 -40.5 -18.5t-34 -43t-23.5 -60.5t-9 -70zM474 591 h-38l-58 -274h37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 238,
    d: "M40 240l35 166h131l-35 -166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 330,
    d: "M22 -127q9 -7 32.5 -13.5t49.5 -6.5t43 8.5t17 29.5q0 14 -12 20t-33 6q-20 0 -43 -4t-35 -7l87 126l56 -18l-45 -52q12 3 28 3q29 0 50.5 -14t21.5 -46q0 -22 -10 -41.5t-29.5 -34.5t-49 -24t-69.5 -9q-33 0 -58.5 6.5t-42.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 299,
    d: "M315 476l-20 -92h-231l20 92h73l51 243q-6 -7 -18.5 -16t-26.5 -17t-29 -13.5t-26 -5.5l20 93q15 0 32.5 9t32.5 19.5t25.5 19.5t10.5 10h94l-73 -342h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 426,
    d: "M219 336q-36 0 -63 12t-45 32.5t-27 48t-9 57.5q0 43 16 84.5t45.5 73t71 51t92.5 19.5q36 0 63 -12t45 -32.5t27 -47.5t9 -58q0 -43 -16 -84t-45 -73t-71 -51.5t-93 -19.5zM240 433q17 0 33 9t28 25t19.5 37t7.5 45q0 31 -13 49.5t-36 18.5q-17 0 -33 -9t-28 -25 t-19.5 -37.5t-7.5 -45.5q0 -30 13 -48.5t36 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 659,
    d: "M607 217l-296 -178l27 129l152 91l-112 98l28 129l217 -193zM296 217l-296 -178l27 129l152 91l-112 98l27 129l218 -193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 848,
    d: "M615 89h-206l20 91l288 251h63l-53 -251h60l-20 -91h-59l-19 -88h-92zM638 180l30 138l-152 -138h122zM103 56l337 324l314 339l58 -64l-327 -315l-325 -349zM304 389l-19 -92h-232l20 92h73l52 243q-7 -7 -19.5 -16t-26.5 -17t-29 -13.5t-26 -5.5l20 93q15 0 32.5 9 t32.5 19.5t25.5 19.5t10.5 10h95l-74 -342h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 881,
    d: "M438 0q8 42 20 73t31 54.5t46 42t66 34.5q26 10 51 20t44.5 21t31.5 25.5t12 35.5q0 20 -16.5 29t-45.5 9q-37 0 -68.5 -15t-52.5 -32l-43 69q12 12 31 24.5t44 22t55.5 16t65.5 6.5q66 0 100 -28.5t34 -81.5q0 -38 -13 -65.5t-34 -47t-47.5 -32t-53.5 -21.5 q-82 -26 -92 -68h195l-19 -91h-342zM68 56l337 324l314 339l58 -64l-327 -315l-325 -349zM304 389l-19 -92h-232l20 92h73l52 243q-7 -7 -19.5 -16t-26.5 -17t-29 -13.5t-26 -5.5l20 93q15 0 32.5 9t32.5 19.5t25.5 19.5t10.5 10h95l-74 -342h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 864,
    d: "M193 289q-60 0 -98 19t-46 57l64 70q1 -4 7 -12.5t17.5 -17.5t29.5 -15.5t44 -6.5q40 0 70 12t30 37q0 24 -34.5 34t-96.5 10h-23l17 85h23q60 0 99 12t39 39q0 9 -6 15.5t-15.5 10t-20.5 5.5t-21 2q-37 0 -64.5 -13t-51.5 -34l-42 75q15 14 35 25t43 18.5t48.5 11 t49.5 3.5q33 0 60 -8t46.5 -21.5t30 -32t10.5 -40.5q0 -42 -31 -69.5t-83 -35.5q40 -6 60.5 -32t20.5 -60q0 -38 -19 -65t-49 -44t-67.5 -25.5t-75.5 -8.5zM628 89h-206l20 91l288 251h63l-53 -251h60l-20 -91h-59l-19 -88h-92zM651 180l30 138l-152 -138h122zM139 56 l337 324l314 339l58 -64l-327 -315l-325 -349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 470,
    d: "M361 261q-5 -23 -11.5 -44t-18.5 -40.5t-31 -36.5t-47 -31q-34 -17 -61 -32t-46 -31t-29.5 -34t-10.5 -40q0 -26 16.5 -41t40.5 -15q18 0 33.5 7.5t28.5 18t24 23t19 23.5l88 -72q-38 -61 -98.5 -95t-128.5 -34q-32 0 -62 9t-53 28t-37.5 49t-14.5 72t10 73.5t27 55.5 t40 42t50 34q22 13 45.5 24.5t43.5 23.5t34 27t18 36h131zM411 506l-32 -150h-131l32 150h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM314 917h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM451 772l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM271 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM486 774q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5 t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM251 780l28 129h132l-28 -129h-132zM456 780l28 129h131l-27 -129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM326 818q0 48 34.5 73t89.5 25q42 0 65 -17t23 -49q0 -47 -34.5 -72t-88.5 -25q-42 0 -65.5 16.5t-23.5 48.5zM439 869q-18 0 -31.5 -11.5t-13.5 -28.5q0 -13 8.5 -21t22.5 -8 q17 0 31.5 11.5t14.5 29.5q0 12 -9 20t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 932,
    d: "M484 710h494l-31 -144h-287l-28 -133h235l-30 -143h-235l-31 -146h294l-30 -144h-458l34 159h-201l-116 -159h-174zM429 303l47 224l-166 -224h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 660,
    d: "M190 -127q9 -7 32.5 -13.5t49.5 -6.5t43 8.5t17 29.5q0 14 -12 20t-33 6q-20 0 -43 -4t-35 -7l61 89q-57 5 -101.5 32.5t-74.5 69t-46 93.5t-16 107q0 49 14.5 99t41 96.5t64.5 86.5t85 70t102 47.5t116 17.5q96 0 157 -43t81 -112l-145 -88q-5 28 -17.5 46.5t-30.5 30 t-39 16t-41 4.5q-52 0 -93 -24.5t-69.5 -63t-43.5 -84.5t-15 -89q0 -34 8.5 -64t25 -53t41.5 -36.5t57 -13.5q21 0 43.5 5.5t45 17t43 30t35.5 45.5l118 -79q-21 -35 -52.5 -63t-68.5 -48.5t-78 -33.5t-80 -17l-30 -35q12 3 28 3q29 0 50.5 -14t21.5 -46q0 -22 -10 -41.5 t-29.5 -34.5t-49 -24t-69.5 -9q-33 0 -58.5 6.5t-42.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476zM310 917h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 576,
    d: "M431 772l-106 14l77 130h144zM155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 576,
    d: "M242 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 576,
    d: "M233 780l28 129h132l-28 -129h-132zM438 780l28 129h131l-27 -129h-132zM155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM158 917h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM272 772l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM98 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM84 780l28 129h132l-28 -129h-132zM289 780l28 129h131l-27 -129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 697,
    d: "M57 416h39l63 294h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254l63 298h-39zM292 144q50 0 91.5 21.5t71 58.5t45.5 85t16 101q0 70 -33.5 113t-99.5 43h-90l-33 -150h119l-26 -118h-118l-33 -154 h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 729,
    d: "M155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164zM528 774q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5 q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 733,
    d: "M301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92 q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5zM378 917h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 733,
    d: "M505 772l-106 14l77 130h144zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25 t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 733,
    d: "M316 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36z M333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 733,
    d: "M301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92 q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5zM535 774q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18 q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 733,
    d: "M301 780l28 129h132l-28 -129h-132zM506 780l28 129h131l-27 -129h-132zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5 t-134.5 -95.5t-160 -36zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 496,
    d: "M435 181l-100 -99l-96 95l-95 -95l-99 99l95 95l-90 91l100 99l90 -90l90 90l99 -99l-90 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 733,
    d: "M783 710l-106 -119q23 -38 34.5 -82.5t11.5 -91.5q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36q-72 0 -128 31l-23 -25h-176l104 117q-23 38 -34 82t-11 92q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q36 0 67.5 -8.5t58.5 -22.5l24 27h176z M333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 11 -1 22t-3 22l-268 -301q21 -9 50 -9zM201 304q0 -25 4 -45l267 300q-11 4 -23 6.5t-26 2.5q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 716,
    d: "M292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5 t-140.5 -27.5zM365 917h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 716,
    d: "M490 772l-106 14l77 130h144zM292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138 t-78.5 -112t-109.5 -75.5t-140.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 716,
    d: "M301 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363 q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5t-140.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 716,
    d: "M287 780l28 129h132l-28 -129h-132zM492 780l28 129h131l-27 -129h-132zM292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5 l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5t-140.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 623,
    d: "M213 244l-136 466h178l69 -326l211 326h178l-338 -468l-51 -242h-164zM434 772l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 584,
    d: "M155 710h164l-26 -124h109q42 0 74.5 -17t55.5 -44.5t35 -63.5t12 -74q0 -51 -22 -101.5t-59.5 -90.5t-87 -64.5t-105.5 -24.5h-115l-22 -106h-164zM327 250q15 0 30.5 9.5t28 26t20 38.5t7.5 46q0 33 -14.5 53t-35.5 20h-101l-41 -193h106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 542,
    d: "M209 141q25 0 48 7t40.5 20.5t27.5 33.5t10 47q0 34 -21.5 52t-44.5 18h-21l31 143h19q17 0 29 6.5t20 17t12 23t4 24.5q0 23 -12.5 34.5t-31.5 11.5q-29 0 -46 -23t-25 -59l-106 -497h-152l112 525q9 41 33 75.5t59 60t78.5 39.5t90.5 14q72 0 116 -36t44 -99 q0 -30 -9.5 -58.5t-25 -52t-35 -40.5t-38.5 -25q42 -16 64.5 -55t22.5 -93q0 -73 -29.5 -122.5t-76 -80t-104 -44t-114.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM223 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM367 586l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM173 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM390 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87 q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM162 593l28 129h132l-28 -129h-132zM367 593l28 129h131l-27 -129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM233 632q0 48 34.5 73t89.5 25q42 0 65 -17t23 -49q0 -47 -34.5 -72t-88.5 -25 q-42 0 -65.5 16.5t-23.5 48.5zM346 683q-18 0 -31.5 -11.5t-13.5 -28.5q0 -13 8.5 -21t22.5 -8q17 0 31.5 11.5t14.5 29.5q0 12 -9 20t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 898,
    d: "M131 -10q-33 0 -59 10.5t-45 28.5t-29 43.5t-10 55.5q0 43 20 80.5t54.5 65t81.5 43t100 15.5q30 0 56 -5.5t45 -14.5q3 14 7 27t4 26q0 29 -19.5 44.5t-60.5 15.5t-81 -14.5t-86 -43.5l-26 100q113 68 232 68q57 0 97.5 -16.5t64.5 -47.5q38 29 84 46.5t100 17.5 t95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -38 -7.5 -63t-14.5 -40h-365q-1 -6 -1.5 -11t-0.5 -12q0 -42 25 -63.5t61 -21.5q32 0 64.5 17t48.5 46l128 -38q-42 -62 -112.5 -101t-158.5 -39q-75 0 -124 28.5t-72 76.5q-24 -28 -52.5 -48t-58 -32.5t-57.5 -18.5t-51 -6z M204 105q15 0 32.5 4.5t34 11.5t30.5 16.5t23 20.5q-1 5 -1.5 10t-0.5 11q0 11 1.5 23t3.5 26q-17 7 -37.5 11t-38.5 4q-21 0 -40.5 -6.5t-34.5 -17.5t-23.5 -26.5t-8.5 -33.5q0 -23 15.5 -38.5t44.5 -15.5zM712 310q1 5 1 9.5v11.5q0 40 -21 64.5t-59 24.5q-42 0 -76 -30 t-48 -80h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 548,
    d: "M120 -127q9 -7 32.5 -13.5t49.5 -6.5t43 8.5t17 29.5q0 14 -12 20t-33 6q-20 0 -43 -4t-35 -7l59 86q-47 5 -82 24t-58.5 48.5t-35 67t-11.5 79.5q0 61 24.5 119.5t68.5 104t105.5 73t135.5 27.5q88 0 139 -38.5t68 -100.5l-165 -47q-19 50 -72 50q-26 0 -51 -13 t-44.5 -35.5t-31 -53.5t-11.5 -68q0 -47 22 -75.5t58 -28.5q26 0 51.5 14.5t41.5 37.5l146 -48q-38 -56 -98 -93t-136 -44l-25 -30q12 3 28 3q29 0 50.5 -14t21.5 -46q0 -22 -10 -41.5t-29.5 -34.5t-49 -24t-69.5 -9q-33 0 -58.5 6.5t-42.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 558,
    d: "M232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10 zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13zM264 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 558,
    d: "M385 586l-106 14l77 130h144zM232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5 t-65.5 -44t-75 -28.5t-79.5 -10zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 558,
    d: "M209 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47 l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 558,
    d: "M193 593l28 129h132l-28 -129h-132zM398 593l28 129h131l-27 -129h-132zM232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27 q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525h-160zM98 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 268,
    d: "M228 586l-106 14l77 130h144zM102 525h160l-112 -525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 268,
    d: "M46 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM102 525h160l-112 -525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 268,
    d: "M27 593l28 129h132l-28 -129h-132zM232 593l28 129h131l-27 -129h-132zM102 525h160l-112 -525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 597,
    d: "M593 651l-77 -38q29 -52 43.5 -113t14.5 -123q0 -88 -26 -159.5t-72 -122t-109.5 -78t-137.5 -27.5q-51 0 -91.5 15t-69.5 41.5t-44.5 63.5t-15.5 81q0 57 24 108t63.5 89.5t90.5 61t106 22.5q42 0 77 -17.5t55 -46.5q-1 17 -2.5 33t-4.5 31q-5 23 -13 44.5t-19 41.5 l-84 -42l-32 61l78 39q-25 30 -58.5 58t-77.5 56h197q20 -11 37 -26.5t32 -33.5l84 42zM175 212q0 -38 22.5 -62.5t61.5 -24.5q27 0 51 10.5t41.5 28.5t28 42.5t10.5 51.5q0 38 -22 62t-62 24q-27 0 -51 -10t-41.5 -28t-28 -42t-10.5 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    d: "M102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160zM417 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7 t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    d: "M229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67 q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28zM272 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    d: "M395 586l-106 14l77 130h144zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13t44 36.5 t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    d: "M209 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28z M258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    d: "M229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67 q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28zM422 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5 t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    d: "M194 593l28 129h132l-28 -129h-132zM399 593l28 129h131l-27 -129h-132zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5 t-136.5 -28zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 513,
    d: "M190 426v143h135v-143h-135zM190 38v143h135v-143h-135zM55 240v127h404v-127h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    d: "M51 73q-20 28 -30 63t-10 73q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q42 0 74.5 -10.5t58.5 -28.5l36 34h87l-80 -75q21 -29 31.5 -64.5t10.5 -74.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28q-43 0 -77 10.5t-60 30.5l-39 -36h-86zM258 125q27 0 52 13 t44.5 36.5t31 54.5t11.5 67q0 20 -5 38l-186 -189q22 -20 52 -20zM178 228q0 -18 3 -34l183 187q-20 18 -48 18q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5 q-45 -52 -100 -76.5t-118 -24.5zM258 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 606,
    d: "M378 586l-106 14l77 130h144zM139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49 q0 6 1.5 13.5t3.5 21.5q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 606,
    d: "M203 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5 q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 606,
    d: "M181 593l28 129h132l-28 -129h-132zM386 593l28 129h131l-27 -129h-132zM139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5 t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 531,
    d: "M-50 -111q30 1 51 4.5t37 10.5t29 18.5t27 29.5l29 37l-78 536h163l29 -388l34 56q51 82 82 161.5t51 170.5h154q-14 -48 -29 -90t-38 -89.5t-56.5 -105t-82.5 -137.5l-80 -129q-35 -57 -69 -96t-70 -63t-76 -35t-88 -11zM349 586l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 576,
    d: "M140 710h165q-11 -50 -19.5 -88.5t-13.5 -64.5q-7 -31 -11 -54q13 17 36 27.5t58 10.5q48 0 84.5 -18.5t61 -49t37 -70t12.5 -81.5q0 -59 -23 -120.5t-65 -112.5t-99.5 -83.5t-126.5 -32.5q-41 0 -58.5 11.5t-22.5 23.5q-6 -29 -13 -63q-6 -29 -14.5 -69.5t-18.5 -88.5 h-165zM260 116q29 0 52 15.5t39.5 40.5t25 57t8.5 66q0 46 -17 74.5t-52 28.5q-28 0 -50 -18.5t-42 -47.5l-33 -155q0 -2 -0.5 -3.5t-0.5 -4.5q0 -8 4.5 -17t13 -17t21.5 -13.5t31 -5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 531,
    d: "M-50 -111q30 1 51 4.5t37 10.5t29 18.5t27 29.5l29 37l-78 536h163l29 -388l34 56q51 82 82 161.5t51 170.5h154q-14 -48 -29 -90t-38 -89.5t-56.5 -105t-82.5 -137.5l-80 -129q-35 -57 -69 -96t-70 -63t-76 -35t-88 -11zM155 593l28 129h132l-28 -129h-132zM360 593 l28 129h131l-27 -129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM283 806l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM192 620l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM428 839q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM335 653q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11 q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 641,
    d: "M496 -205q-57 8 -84.5 30.5t-27.5 51.5q0 64 106 123h-80l-15 159h-202l-81 -159h-169l394 710h149l92 -710q-89 -51 -89 -88q0 -14 13.5 -23t42.5 -10zM392 272l-20 251l-130 -251h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 634,
    d: "M452 -205q-57 8 -84.5 30.5t-27.5 51.5q0 61 97 118q-26 5 -41 20t-15 44q0 10 3 28q-37 -49 -86.5 -73t-100.5 -24q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5 t-0.5 -9.5q0 -23 25 -24l-28 -135q-89 -51 -89 -88q0 -14 13.5 -23t42.5 -10zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 661,
    d: "M513 772l-106 14l77 130h144zM297 -6q-63 0 -112 25.5t-83 68t-51.5 97t-17.5 112.5q0 49 14.5 99t41 96.5t64.5 86.5t85 70t102 47.5t116 17.5q96 0 157 -43t81 -112l-145 -88q-5 28 -17.5 46.5t-30.5 30t-39 16t-41 4.5q-52 0 -93 -24.5t-69.5 -63t-43.5 -84.5t-15 -89 q0 -34 8.5 -64t25 -53t41.5 -36.5t57 -13.5q21 0 43.5 5.5t45 17t43 30t35.5 45.5l118 -79q-24 -39 -61 -70t-80.5 -52t-90 -32t-88.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 548,
    d: "M383 586l-106 14l77 130h144zM230 -10q-55 0 -96 17.5t-68.5 48t-41 70.5t-13.5 85q0 61 24.5 119.5t68.5 104t105.5 73t135.5 27.5q88 0 139 -38.5t68 -100.5l-165 -47q-19 50 -72 50q-26 0 -51 -13t-44.5 -35.5t-31 -53.5t-11.5 -68q0 -47 22 -75.5t58 -28.5 q26 0 51.5 14.5t41.5 37.5l146 -48q-42 -61 -110 -100t-156 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 661,
    d: "M316 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM297 -6q-63 0 -112 25.5t-83 68t-51.5 97t-17.5 112.5q0 49 14.5 99t41 96.5t64.5 86.5t85 70t102 47.5t116 17.5q96 0 157 -43t81 -112l-145 -88q-5 28 -17.5 46.5t-30.5 30t-39 16t-41 4.5q-52 0 -93 -24.5 t-69.5 -63t-43.5 -84.5t-15 -89q0 -34 8.5 -64t25 -53t41.5 -36.5t57 -13.5q21 0 43.5 5.5t45 17t43 30t35.5 45.5l118 -79q-24 -39 -61 -70t-80.5 -52t-90 -32t-88.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 548,
    d: "M206 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM230 -10q-55 0 -96 17.5t-68.5 48t-41 70.5t-13.5 85q0 61 24.5 119.5t68.5 104t105.5 73t135.5 27.5q88 0 139 -38.5t68 -100.5l-165 -47q-19 50 -72 50q-26 0 -51 -13t-44.5 -35.5t-31 -53.5t-11.5 -68 q0 -47 22 -75.5t58 -28.5q26 0 51.5 14.5t41.5 37.5l146 -48q-42 -61 -110 -100t-156 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 661,
    d: "M297 -6q-63 0 -112 25.5t-83 68t-51.5 97t-17.5 112.5q0 49 14.5 99t41 96.5t64.5 86.5t85 70t102 47.5t116 17.5q96 0 157 -43t81 -112l-145 -88q-5 28 -17.5 46.5t-30.5 30t-39 16t-41 4.5q-52 0 -93 -24.5t-69.5 -63t-43.5 -84.5t-15 -89q0 -34 8.5 -64t25 -53 t41.5 -36.5t57 -13.5q21 0 43.5 5.5t45 17t43 30t35.5 45.5l118 -79q-24 -39 -61 -70t-80.5 -52t-90 -32t-88.5 -11zM401 779l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 548,
    d: "M230 -10q-55 0 -96 17.5t-68.5 48t-41 70.5t-13.5 85q0 61 24.5 119.5t68.5 104t105.5 73t135.5 27.5q88 0 139 -38.5t68 -100.5l-165 -47q-19 50 -72 50q-26 0 -51 -13t-44.5 -35.5t-31 -53.5t-11.5 -68q0 -47 22 -75.5t58 -28.5q26 0 51.5 14.5t41.5 37.5l146 -48 q-42 -61 -110 -100t-156 -39zM285 593l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 661,
    d: "M328 879l89 37l67 -63l94 63l75 -37l-128 -107h-115zM297 -6q-63 0 -112 25.5t-83 68t-51.5 97t-17.5 112.5q0 49 14.5 99t41 96.5t64.5 86.5t85 70t102 47.5t116 17.5q96 0 157 -43t81 -112l-145 -88q-5 28 -17.5 46.5t-30.5 30t-39 16t-41 4.5q-52 0 -93 -24.5 t-69.5 -63t-43.5 -84.5t-15 -89q0 -34 8.5 -64t25 -53t41.5 -36.5t57 -13.5q21 0 43.5 5.5t45 17t43 30t35.5 45.5l118 -79q-24 -39 -61 -70t-80.5 -52t-90 -32t-88.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 548,
    d: "M214 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM230 -10q-55 0 -96 17.5t-68.5 48t-41 70.5t-13.5 85q0 61 24.5 119.5t68.5 104t105.5 73t135.5 27.5q88 0 139 -38.5t68 -100.5l-165 -47q-19 50 -72 50q-26 0 -51 -13t-44.5 -35.5t-31 -53.5t-11.5 -68 q0 -47 22 -75.5t58 -28.5q26 0 51.5 14.5t41.5 37.5l146 -48q-42 -61 -110 -100t-156 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 693,
    d: "M268 879l89 37l67 -63l94 63l75 -37l-128 -107h-115zM155 710h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254zM288 144q50 0 91 21.5t70.5 58.5t45.5 85t16 101q0 70 -33.5 113t-99.5 43h-90 l-90 -422h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 634,
    d: "M670 600l77 130h144l-125 -158zM197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l62 291h161l-118 -550q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5 q-38 0 -62 15t-24 49q0 12 4 31q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 697,
    d: "M57 416h39l63 294h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254l63 298h-39zM292 144q50 0 91.5 21.5t71 58.5t45.5 85t16 101q0 70 -33.5 113t-99.5 43h-90l-33 -150h119l-26 -118h-118l-33 -154 h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 634,
    d: "M409 679h76l11 51h161l-11 -51h67l-20 -94h-67l-87 -405q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-84 0 -84 65v12.5t2 17.5q-37 -49 -86.5 -73t-100.5 -24q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5 t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l31 146h-76zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476zM262 806l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 558,
    d: "M232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10 zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13zM218 620l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476zM405 839q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 558,
    d: "M232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10 zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13zM365 653q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476zM328 779l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 558,
    d: "M232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10 zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13zM288 593l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-188q-87 -50 -87 -87q0 -14 13.5 -23t42.5 -10l-49 -84q-57 8 -84.5 30.5t-27.5 51.5q0 30 26 61.5t79 60.5h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 558,
    d: "M209 -209q-57 8 -84.5 30.5t-27.5 51.5q0 61 100 119q-87 11 -136 70t-49 150q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-35 -51 -91.5 -86.5 t-121.5 -46.5q-88 -51 -88 -88q0 -14 13.5 -23t42.5 -10zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 576,
    d: "M254 879l89 37l67 -63l94 63l75 -37l-128 -107h-115zM155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 558,
    d: "M214 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47 l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 704,
    d: "M315 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM481 70q-48 -38 -93.5 -56.5t-96.5 -18.5q-57 0 -104 21t-81.5 59t-53.5 91.5t-19 118.5q0 88 35.5 166.5t95 137t136 92.5t158.5 34q93 0 155.5 -41.5t82.5 -113.5l-141 -92q-13 48 -49.5 74.5t-84.5 26.5 q-44 0 -83.5 -21.5t-69.5 -58t-48 -84.5t-18 -101q0 -35 9 -65t26.5 -52t42 -34t56.5 -12q89 0 179 88l5 23h-129l25 119h265l-79 -371h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 618,
    d: "M196 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM160 -223q-81 0 -133 27t-84 78l104 87q20 -33 56.5 -52.5t81.5 -19.5q27 0 53 8t48 24.5t38 43t24 63.5l10 51q-31 -44 -78.5 -66.5t-96.5 -22.5q-41 0 -72.5 16t-53.5 44t-33.5 65.5t-11.5 81.5q0 67 24 127 t65 105t95 71.5t114 26.5q55 0 91.5 -25.5t52.5 -70.5l19 86h139l-104 -489q-13 -60 -44.5 -108t-77 -81.5t-103.5 -51.5t-123 -18zM267 125q32 0 62 20.5t53 52.5l24 110q-6 42 -31 66.5t-57 24.5q-27 0 -52.5 -15t-44.5 -39t-30.5 -54.5t-11.5 -61.5q0 -45 23.5 -74.5 t64.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 704,
    d: "M481 70q-48 -38 -93.5 -56.5t-96.5 -18.5q-57 0 -104 21t-81.5 59t-53.5 91.5t-19 118.5q0 88 35.5 166.5t95 137t136 92.5t158.5 34q93 0 155.5 -41.5t82.5 -113.5l-141 -92q-13 48 -49.5 74.5t-84.5 26.5q-44 0 -83.5 -21.5t-69.5 -58t-48 -84.5t-18 -101q0 -35 9 -65 t26.5 -52t42 -34t56.5 -12q89 0 179 88l5 23h-129l25 119h265l-79 -371h-136zM477 839q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 618,
    d: "M160 -223q-81 0 -133 27t-84 78l104 87q20 -33 56.5 -52.5t81.5 -19.5q27 0 53 8t48 24.5t38 43t24 63.5l10 51q-31 -44 -78.5 -66.5t-96.5 -22.5q-41 0 -72.5 16t-53.5 44t-33.5 65.5t-11.5 81.5q0 67 24 127t65 105t95 71.5t114 26.5q55 0 91.5 -25.5t52.5 -70.5l19 86 h139l-104 -489q-13 -60 -44.5 -108t-77 -81.5t-103.5 -51.5t-123 -18zM267 125q32 0 62 20.5t53 52.5l24 110q-6 42 -31 66.5t-57 24.5q-27 0 -52.5 -15t-44.5 -39t-30.5 -54.5t-11.5 -61.5q0 -45 23.5 -74.5t64.5 -29.5zM358 653q21 0 41.5 21.5t31.5 55.5h84 q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 704,
    d: "M481 70q-48 -38 -93.5 -56.5t-96.5 -18.5q-57 0 -104 21t-81.5 59t-53.5 91.5t-19 118.5q0 88 35.5 166.5t95 137t136 92.5t158.5 34q93 0 155.5 -41.5t82.5 -113.5l-141 -92q-13 48 -49.5 74.5t-84.5 26.5q-44 0 -83.5 -21.5t-69.5 -58t-48 -84.5t-18 -101q0 -35 9 -65 t26.5 -52t42 -34t56.5 -12q89 0 179 88l5 23h-129l25 119h265l-79 -371h-136zM400 779l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 618,
    d: "M160 -223q-81 0 -133 27t-84 78l104 87q20 -33 56.5 -52.5t81.5 -19.5q27 0 53 8t48 24.5t38 43t24 63.5l10 51q-31 -44 -78.5 -66.5t-96.5 -22.5q-41 0 -72.5 16t-53.5 44t-33.5 65.5t-11.5 81.5q0 67 24 127t65 105t95 71.5t114 26.5q55 0 91.5 -25.5t52.5 -70.5l19 86 h139l-104 -489q-13 -60 -44.5 -108t-77 -81.5t-103.5 -51.5t-123 -18zM267 125q32 0 62 20.5t53 52.5l24 110q-6 42 -31 66.5t-57 24.5q-27 0 -52.5 -15t-44.5 -39t-30.5 -54.5t-11.5 -61.5q0 -45 23.5 -74.5t64.5 -29.5zM280 593l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 704,
    d: "M209 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM481 70q-48 -38 -93.5 -56.5t-96.5 -18.5q-57 0 -104 21t-81.5 59t-53.5 91.5t-19 118.5q0 88 35.5 166.5t95 137t136 92.5t158.5 34q93 0 155.5 -41.5t82.5 -113.5l-141 -92q-13 48 -49.5 74.5t-84.5 26.5 q-44 0 -83.5 -21.5t-69.5 -58t-48 -84.5t-18 -101q0 -35 9 -65t26.5 -52t42 -34t56.5 -12q89 0 179 88l5 23h-129l25 119h265l-79 -371h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 618,
    d: "M431 745l-45 -67h47l-21 -99h-133l21 99l61 67h70zM160 -223q-81 0 -133 27t-84 78l104 87q20 -33 56.5 -52.5t81.5 -19.5q27 0 53 8t48 24.5t38 43t24 63.5l10 51q-31 -44 -78.5 -66.5t-96.5 -22.5q-41 0 -72.5 16t-53.5 44t-33.5 65.5t-11.5 81.5q0 67 24 127t65 105 t95 71.5t114 26.5q55 0 91.5 -25.5t52.5 -70.5l19 86h139l-104 -489q-13 -60 -44.5 -108t-77 -81.5t-103.5 -51.5t-123 -18zM267 125q32 0 62 20.5t53 52.5l24 110q-6 42 -31 66.5t-57 24.5q-27 0 -52.5 -15t-44.5 -39t-30.5 -54.5t-11.5 -61.5q0 -45 23.5 -74.5t64.5 -29.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 721,
    d: "M306 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM155 710h164l-59 -275h257l59 275h164l-151 -710h-164l62 291h-257l-62 -291h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    d: "M307 622l118 107h106l76 -107l-82 -35l-63 62l-87 -62zM145 730h160l-62 -293q37 47 87 72.5t105 25.5q36 0 59.5 -10t38 -26.5t20 -38.5t5.5 -46q0 -19 -2.5 -38.5t-6.5 -39.5l-71 -336h-160l63 295q2 11 3 20.5t1 18.5q0 31 -14 45.5t-38 14.5q-12 0 -28 -6.5 t-32.5 -19t-32 -29.5t-26.5 -38l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 727,
    d: "M92 617h47l20 93h164l-20 -93h257l20 93h164l-20 -93h47l-16 -76h-47l-115 -541h-164l62 291h-257l-62 -291h-164l115 541h-48zM521 435l22 106h-257l-22 -106h257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    d: "M81 679h53l11 51h160l-11 -51h92l-20 -94h-92l-31 -148q37 47 87 72.5t105 25.5q36 0 59.5 -10t38 -26.5t20 -38.5t5.5 -46q0 -19 -2.5 -38.5t-6.5 -39.5l-71 -336h-160l63 295q2 11 3 20.5t1 18.5q0 31 -14 45.5t-38 14.5q-12 0 -28 -6.5t-32.5 -19t-32 -29.5t-26.5 -38 l-64 -301h-160l124 585h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM319 774q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85 q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525h-160zM260 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85 q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM113 806l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525h-160zM55 620l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM261 839q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525h-160zM200 653q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710q-89 -51 -89 -88q0 -14 13.5 -23t42.5 -10l-49 -84q-57 8 -84.5 30.5t-27.5 51.5q0 64 106 123h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525q-89 -51 -89 -88q0 -14 13.5 -23t42.5 -10l-49 -84q-57 8 -84.5 30.5t-27.5 51.5q0 64 106 123h-72zM145 730h160l-31 -145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM181 779l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 783,
    d: "M155 710h164l-151 -710h-164zM392 -11q-85 0 -137 44l63 134q7 -8 35.5 -20t69.5 -12q33 0 55.5 12.5t38.5 38.5t28 66.5t24 96.5l77 361h165l-77 -361q-17 -81 -39.5 -147.5t-60 -113.5t-96 -73t-146.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 541,
    d: "M102 525h160l-112 -525h-160zM145 730h160l-31 -145h-160zM193 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q20 0 37 14.5t22 40.5l113 534h160l-110 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15zM418 730h160l-31 -145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 483,
    d: "M286 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM92 -11q-85 0 -137 44l63 134q7 -8 35.5 -20t69.5 -12q33 0 55.5 12.5t38.5 38.5t28 66.5t24 96.5l77 361h165l-77 -361q-17 -81 -39.5 -147.5t-60 -113.5t-96 -73t-146.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 268,
    d: "M-80 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q21 0 37.5 15t21.5 40l113 534h161l-111 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15zM38 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 653,
    d: "M202 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM155 710h164l-65 -306l300 306h185l-319 -317l184 -393h-188l-123 286l-81 -77l-44 -209h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 570,
    d: "M145 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM145 730h159l-71 -336q40 64 91.5 100.5t111.5 36.5q55 0 83.5 -31t28.5 -87q0 -66 -36.5 -122t-105.5 -93l89 -198h-170l-88 227q79 15 123 48.5t44 74.5q0 22 -12 33.5t-32 11.5q-21 0 -44 -12.5t-45 -33.5 t-40.5 -49.5t-30.5 -60.5l-51 -239h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 550,
    d: "M102 525h160l-47 -218l206 218h168l-225 -226l130 -299h-170l-80 211l-61 -58l-33 -153h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 563,
    d: "M280 772l-106 14l77 130h144zM155 710h164l-121 -566h321l-30 -144h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 326,
    d: "M258 747l-106 14l77 130h144zM126 -9q-57 0 -86 25t-29 73q0 10 1.5 20t3.5 22l127 599h160l-116 -543q-1 -5 -1.5 -10.5t-0.5 -10.5q0 -39 38 -39q11 0 25.5 3.5t27.5 10.5l-5 -120q-32 -14 -72 -22t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 563,
    d: "M156 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM155 710h164l-121 -566h321l-30 -144h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 326,
    d: "M19 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM126 -9q-57 0 -86 25t-29 73q0 10 1.5 20t3.5 22l127 599h160l-116 -543q-1 -5 -1.5 -10.5t-0.5 -10.5q0 -39 38 -39q11 0 25.5 3.5t27.5 10.5l-5 -120q-32 -14 -72 -22t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 563,
    d: "M357 600l77 130h144l-125 -158zM155 710h164l-121 -566h321l-30 -144h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 323,
    d: "M313 600l77 130h144l-125 -158zM126 -9q-57 0 -86 25t-29 73q0 10 1.5 20t3.5 22l127 599h160l-116 -543q-1 -5 -1.5 -10.5t-0.5 -10.5q0 -39 38 -39q11 0 25.5 3.5t27.5 10.5l-5 -120q-32 -14 -72 -22t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 563,
    d: "M155 710h164l-121 -566h321l-30 -144h-485zM341 338l35 166h131l-35 -166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 431,
    d: "M126 -9q-57 0 -86 25t-29 73q0 10 1.5 20t3.5 22l127 599h160l-116 -543q-1 -5 -1.5 -10.5t-0.5 -10.5q0 -39 38 -39q11 0 25.5 3.5t27.5 10.5l-5 -120q-32 -14 -72 -22t-73 -8zM278 264l35 166h131l-35 -166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 571,
    d: "M0 332l94 49l70 329h164l-50 -233l93 49l19 -86l-135 -71l-48 -225h321l-30 -144h-485l58 273l-52 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 367,
    d: "M7 347l105 52l70 331h160l-51 -241l73 37l20 -86l-116 -58l-40 -189q-2 -8 -3 -15t-1 -12q0 -39 39 -39q11 0 25.5 3.5t27.5 10.5l-5 -120q-33 -14 -73 -22t-72 -8q-57 0 -86.5 25t-29.5 73q0 17 5 42l34 161l-63 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 729,
    d: "M493 772l-106 14l77 130h144zM155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    d: "M386 586l-106 14l77 130h144zM102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 729,
    d: "M213 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    d: "M139 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 729,
    d: "M310 879l89 37l67 -63l94 63l75 -37l-128 -107h-115zM155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    d: "M209 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    d: "M-74 600l49 80v50h172l-126 -158zM102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 713,
    d: "M351 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 19 -16t26 -5q20 0 36.5 15t21.5 40l10 44l-176 366l-85 -401h-164l151 710h126l200 -409l87 408h164l-152 -711q-10 -45 -32.5 -82t-53 -63.5t-67.5 -40.5t-76 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 590,
    d: "M247 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q20 0 37.5 14.5t22.5 40.5l65 304q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160l112 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -9.5t36 -26t19 -38t5.5 -45.5 q0 -20 -2.5 -40t-7.5 -40l-71 -333q-10 -45 -32 -83t-53 -65t-68 -42t-77 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 733,
    d: "M330 806l20 97h291l-21 -97h-290zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25 t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    d: "M222 620l20 97h291l-21 -97h-290zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13 t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 733,
    d: "M301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92 q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5zM481 839q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84 q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    d: "M229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67 q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28zM369 653q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 733,
    d: "M398 757l-81 12l68 130h119zM568 757l-81 12l67 130h120zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36z M333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    d: "M299 588l-81 12l68 130h119zM469 588l-81 12l67 130h120zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28z M258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1006,
    d: "M286 -5q-61 0 -108 24.5t-79.5 65t-49 93.5t-16.5 110q0 81 34 158t90.5 137t130.5 96t155 36q48 0 83.5 -22t60.5 -57l15 74h451l-31 -144h-286l-29 -133h236l-31 -143h-235l-32 -146h296l-31 -144h-459l16 75q-40 -35 -86.5 -57.5t-94.5 -22.5zM318 141q48 0 86.5 25.5 t66 64.5t42 86.5t14.5 92.5q0 32 -7 61t-22 50.5t-37 34.5t-52 13q-47 0 -85.5 -25t-66 -64.5t-42.5 -87t-15 -92.5q0 -32 7 -61t22 -50.5t37 -34.5t52 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 956,
    d: "M228 -10q-50 0 -90.5 16t-68.5 45t-43 69t-15 88q0 69 26.5 128.5t72 103.5t105.5 69.5t127 25.5q60 0 101 -27t66 -79q53 54 103.5 80t109.5 26q50 0 90 -16t67.5 -45.5t42.5 -70t15 -88.5q0 -38 -7.5 -62.5t-14.5 -39.5h-363q-1 -6 -1.5 -10.5t-0.5 -9.5 q0 -40 24 -65.5t62 -25.5q35 0 68 18.5t49 47.5l124 -38q-23 -32 -52.5 -58t-64.5 -44t-74 -28t-79 -10q-54 0 -93 24.5t-77 75.5q-60 -53 -108 -76.5t-101 -23.5zM258 125q28 0 53 13.5t44 37t30 54.5t11 67q0 45 -21 73.5t-59 28.5q-28 0 -53 -13.5t-44 -37t-30 -54.5 t-11 -67q0 -45 21 -73.5t59 -28.5zM773 310q1 5 1.5 9.5t0.5 8.5q0 42 -22 67t-60 25q-42 0 -76.5 -30.5t-48.5 -79.5h205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 647,
    d: "M451 774l-106 14l77 130h144zM4 0l151 710h305q42 0 74.5 -17t55 -45t34.5 -64t12 -74q0 -37 -11.5 -73t-32 -68.5t-49 -59.5t-62.5 -45l91 -264h-185l-78 229h-93l-48 -229h-164zM383 372q15 0 30 9.5t27 26t19.5 38.5t7.5 47q0 33 -14 53t-34 20h-131l-41 -194h136z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 392,
    d: "M303 586l-106 14l77 130h144zM102 525h147l-23 -106q38 53 84.5 83t91.5 30q19 0 23 -1l-30 -143q-54 -1 -101.5 -19t-76.5 -54l-67 -315h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 647,
    d: "M168 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM4 0l151 710h305q42 0 74.5 -17t55 -45t34.5 -64t12 -74q0 -37 -11.5 -73t-32 -68.5t-49 -59.5t-62.5 -45l91 -264h-185l-78 229h-93l-48 -229h-164zM383 372q15 0 30 9.5t27 26t19.5 38.5t7.5 47q0 33 -14 53t-34 20 h-131l-41 -194h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 392,
    d: "M-26 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM102 525h147l-23 -106q38 53 84.5 83t91.5 30q19 0 23 -1l-30 -143q-54 -1 -101.5 -19t-76.5 -54l-67 -315h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 647,
    d: "M269 881l89 37l67 -63l94 63l75 -37l-128 -107h-115zM4 0l151 710h305q42 0 74.5 -17t55 -45t34.5 -64t12 -74q0 -37 -11.5 -73t-32 -68.5t-49 -59.5t-62.5 -45l91 -264h-185l-78 229h-93l-48 -229h-164zM383 372q15 0 30 9.5t27 26t19.5 38.5t7.5 47q0 33 -14 53t-34 20 h-131l-41 -194h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 392,
    d: "M128 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM102 525h147l-23 -106q38 53 84.5 83t91.5 30q19 0 23 -1l-30 -143q-54 -1 -101.5 -19t-76.5 -54l-67 -315h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 594,
    d: "M442 786l-106 14l77 130h144zM244 -8q-75 0 -147 23t-124 65l102 143q2 -5 19.5 -19t45 -28t63.5 -25t75 -11q48 0 68 17.5t20 45.5q0 17 -11 28.5t-30.5 21t-45 18t-54.5 18.5q-72 26 -107.5 61t-35.5 94q0 64 26 115t68.5 85.5t97.5 53t113 18.5q36 0 69 -7t62 -18 t53.5 -25t44.5 -28l-100 -136q-2 4 -16.5 15t-37.5 23t-52 21t-59 9q-42 0 -65.5 -18.5t-23.5 -51.5q0 -29 31 -43.5t88 -32.5q38 -12 69.5 -26.5t54 -34.5t34.5 -47t12 -64q0 -71 -27 -120.5t-71 -80.5t-99 -45t-110 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 482,
    d: "M334 586l-106 14l77 130h144zM187 -10q-63 0 -120.5 21.5t-92.5 62.5l77 98q38 -33 78 -51t79 -18q32 0 48 13.5t16 36.5q0 17 -16.5 28.5t-57.5 24.5t-70.5 25.5t-48.5 27t-28 32t-9 40.5q0 44 19.5 81.5t52.5 64.5t77 42.5t94 15.5q56 0 101.5 -16t83.5 -58l-82 -96 q-37 31 -67 45t-60 14q-27 0 -45 -13t-18 -39q0 -17 17 -27.5t56 -21.5q86 -25 124 -54t38 -79q0 -44 -18 -81t-50.5 -63.5t-77.5 -41t-100 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 594,
    d: "M256 822l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM244 -8q-75 0 -147 23t-124 65l102 143q2 -5 19.5 -19t45 -28t63.5 -25t75 -11q48 0 68 17.5t20 45.5q0 17 -11 28.5t-30.5 21t-45 18t-54.5 18.5q-72 26 -107.5 61t-35.5 94q0 64 26 115t68.5 85.5t97.5 53 t113 18.5q36 0 69 -7t62 -18t53.5 -25t44.5 -28l-100 -136q-2 4 -16.5 15t-37.5 23t-52 21t-59 9q-42 0 -65.5 -18.5t-23.5 -51.5q0 -29 31 -43.5t88 -32.5q38 -12 69.5 -26.5t54 -34.5t34.5 -47t12 -64q0 -71 -27 -120.5t-71 -80.5t-99 -45t-110 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 482,
    d: "M158 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM187 -10q-63 0 -120.5 21.5t-92.5 62.5l77 98q38 -33 78 -51t79 -18q32 0 48 13.5t16 36.5q0 17 -16.5 28.5t-57.5 24.5t-70.5 25.5t-48.5 27t-28 32t-9 40.5q0 44 19.5 81.5t52.5 64.5t77 42.5t94 15.5 q56 0 101.5 -16t83.5 -58l-82 -96q-37 31 -67 45t-60 14q-27 0 -45 -13t-18 -39q0 -17 17 -27.5t56 -21.5q86 -25 124 -54t38 -79q0 -44 -18 -81t-50.5 -63.5t-77.5 -41t-100 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 594,
    d: "M135 -127q9 -7 32.5 -13.5t49.5 -6.5t43 8.5t17 29.5q0 14 -12 20t-33 6q-20 0 -43 -4t-35 -7l60 87q-68 5 -131 27t-110 60l102 143q2 -5 19.5 -19t45 -28t63.5 -25t75 -11q48 0 68 17.5t20 45.5q0 17 -11 28.5t-30.5 21t-45 18t-54.5 18.5q-72 26 -107.5 61t-35.5 94 q0 64 26 115t68.5 85.5t97.5 53t113 18.5q36 0 69 -7t62 -18t53.5 -25t44.5 -28l-100 -136q-2 4 -16.5 15t-37.5 23t-52 21t-59 9q-42 0 -65.5 -18.5t-23.5 -51.5q0 -29 31 -43.5t88 -32.5q38 -12 69.5 -26.5t54 -34.5t34.5 -47t12 -64q0 -65 -23 -112.5t-61.5 -78.5 t-87.5 -47.5t-100 -20.5l-27 -31q12 3 28 3q29 0 50.5 -14t21.5 -46q0 -22 -10 -41.5t-29.5 -34.5t-49 -24t-69.5 -9q-33 0 -58.5 6.5t-42.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 482,
    d: "M68 -127q9 -7 32.5 -13.5t49.5 -6.5t43 8.5t17 29.5q0 14 -12 20t-33 6q-20 0 -43 -4t-35 -7l59 86q-52 6 -97.5 26.5t-74.5 55.5l77 98q38 -33 78 -51t79 -18q32 0 48 13.5t16 36.5q0 17 -16.5 28.5t-57.5 24.5t-70.5 25.5t-48.5 27t-28 32t-9 40.5q0 44 19.5 81.5 t52.5 64.5t77 42.5t94 15.5q56 0 101.5 -16t83.5 -58l-82 -96q-37 31 -67 45t-60 14q-27 0 -45 -13t-18 -39q0 -17 17 -27.5t56 -21.5q86 -25 124 -54t38 -79q0 -42 -16 -77t-45.5 -61.5t-70.5 -42t-91 -18.5l-25 -29q12 3 28 3q29 0 50.5 -14t21.5 -46q0 -22 -10 -41.5 t-29.5 -34.5t-49 -24t-69.5 -9q-33 0 -58.5 6.5t-42.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 594,
    d: "M263 893l89 37l67 -63l94 63l75 -37l-128 -107h-115zM244 -8q-75 0 -147 23t-124 65l102 143q2 -5 19.5 -19t45 -28t63.5 -25t75 -11q48 0 68 17.5t20 45.5q0 17 -11 28.5t-30.5 21t-45 18t-54.5 18.5q-72 26 -107.5 61t-35.5 94q0 64 26 115t68.5 85.5t97.5 53t113 18.5 q36 0 69 -7t62 -18t53.5 -25t44.5 -28l-100 -136q-2 4 -16.5 15t-37.5 23t-52 21t-59 9q-42 0 -65.5 -18.5t-23.5 -51.5q0 -29 31 -43.5t88 -32.5q38 -12 69.5 -26.5t54 -34.5t34.5 -47t12 -64q0 -71 -27 -120.5t-71 -80.5t-99 -45t-110 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 482,
    d: "M159 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM187 -10q-63 0 -120.5 21.5t-92.5 62.5l77 98q38 -33 78 -51t79 -18q32 0 48 13.5t16 36.5q0 17 -16.5 28.5t-57.5 24.5t-70.5 25.5t-48.5 27t-28 32t-9 40.5q0 44 19.5 81.5t52.5 64.5t77 42.5t94 15.5 q56 0 101.5 -16t83.5 -58l-82 -96q-37 31 -67 45t-60 14q-27 0 -45 -13t-18 -39q0 -17 17 -27.5t56 -21.5q86 -25 124 -54t38 -79q0 -44 -18 -81t-50.5 -63.5t-77.5 -41t-100 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 596,
    d: "M273 566h-203l30 144h569l-30 -144h-202l-121 -566h-53l-33 -38q12 3 28 3q29 0 50.5 -14t21.5 -46q0 -22 -10 -41.5t-29.5 -34.5t-49 -24t-69.5 -9q-33 0 -58.5 6.5t-42.5 14.5l42 56q9 -7 32.5 -13.5t49.5 -6.5t43 8.5t17 29.5q0 14 -12 20t-33 6q-20 0 -43 -4t-35 -7 l65 94h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 392,
    d: "M37 -127q9 -7 32.5 -13.5t49.5 -6.5t43 8.5t17 29.5q0 14 -12 20t-33 6q-20 0 -43 -4t-35 -7l61 89q-32 8 -51.5 30t-19.5 64q0 21 4 41l58 274h-63l27 121h62l36 167h160l-36 -167h101l-26 -121h-101l-46 -219q-1 -5 -1.5 -9t-0.5 -8q0 -17 9.5 -24.5t24.5 -7.5 q16 0 36 6t37 13v-127q-33 -14 -72 -24.5t-77 -12.5l-24 -29q12 3 28 3q29 0 50.5 -14t21.5 -46q0 -22 -10 -41.5t-29.5 -34.5t-49 -24t-69.5 -9q-33 0 -58.5 6.5t-42.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 596,
    d: "M252 879l89 37l67 -63l94 63l75 -37l-128 -107h-115zM273 566h-203l30 144h569l-30 -144h-202l-121 -566h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 392,
    d: "M364 600l77 130h144l-125 -158zM163 -10q-51 0 -84 22.5t-33 76.5q0 21 4 41l58 274h-63l27 121h62l36 167h160l-36 -167h101l-26 -121h-101l-46 -219q-1 -5 -1.5 -9t-0.5 -8q0 -17 9.5 -24.5t24.5 -7.5q16 0 36 6t37 13v-127q-36 -16 -79 -27t-85 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 619,
    d: "M76 368h165l42 198h-202l30 144h569l-31 -144h-202l-42 -198h166l-16 -76h-166l-61 -292h-165l62 292h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 394,
    d: "M33 340h63l14 64h-63l26 121h63l36 167h160l-36 -167h100l-25 -121h-101l-14 -64h101l-19 -93h-102l-12 -57q-2 -7 -2 -11.5v-9.5q0 -33 34 -33q16 0 36 6t37 13v-127q-36 -16 -79.5 -27t-85.5 -11q-50 0 -83.5 22.5t-33.5 76.5q0 10 1.5 19.5t3.5 21.5l25 117h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 716,
    d: "M292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5 t-140.5 -27.5zM519 774q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48 t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5 q-45 -52 -100 -76.5t-118 -24.5zM413 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85 q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 716,
    d: "M292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5 t-140.5 -27.5zM316 806l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5 q-45 -52 -100 -76.5t-118 -24.5zM210 620l20 97h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 716,
    d: "M292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5 t-140.5 -27.5zM456 839q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5 q-45 -52 -100 -76.5t-118 -24.5zM355 653q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 716,
    d: "M362 818q0 48 34.5 73t89.5 25q42 0 65 -17t23 -49q0 -47 -34.5 -72t-88.5 -25q-42 0 -65.5 16.5t-23.5 48.5zM475 869q-18 0 -31.5 -11.5t-13.5 -28.5q0 -13 8.5 -21t22.5 -8q17 0 31.5 11.5t14.5 29.5q0 12 -9 20t-23 8zM292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77 t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5t-140.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 606,
    d: "M255 632q0 48 34.5 73t89.5 25q42 0 65 -17t23 -49q0 -47 -34.5 -72t-88.5 -25q-42 0 -65.5 16.5t-23.5 48.5zM368 683q-18 0 -31.5 -11.5t-13.5 -28.5q0 -13 8.5 -21t22.5 -8q17 0 31.5 11.5t14.5 29.5q0 12 -9 20t-23 8zM139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336 h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 716,
    d: "M292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5 t-140.5 -27.5zM380 775l-81 12l68 130h119zM550 775l-81 12l67 130h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5 q-45 -52 -100 -76.5t-118 -24.5zM269 588l-81 12l68 130h119zM439 588l-81 12l67 130h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 716,
    d: "M271 -204q-57 8 -84.5 30.5t-27.5 51.5q0 61 97 118q-55 5 -93.5 25t-62.5 52t-35 73.5t-11 89.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363 q-14 -67 -41.5 -126t-67.5 -105.5t-93 -77.5t-119 -40q-83 -48 -83 -85q0 -14 13.5 -23t42.5 -10l-49 -84v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-89 -51 -89 -88q0 -14 13.5 -23t42.5 -10l-49 -84q-57 8 -84.5 30.5t-27.5 51.5q0 61 97 118 q-26 5 -41.5 19.5t-15.5 41.5q0 6 1.5 13.5t3.5 21.5q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1002,
    d: "M442 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM76 710h178l52 -522l102 191l-40 330h150l18 -227l114 227h151l-183 -330l23 -191l273 522h180l-420 -710h-136l-46 278l-162 -278h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 802,
    d: "M302 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63zM38 525h154l51 -380q5 6 15 24.5t21.5 39.5t21 39.5t13.5 24.5l-48 252h133l18 -159q3 6 14 29.5t23.5 50t22.5 50t12 29.5h123q-27 -72 -56.5 -131t-71.5 -120l17 -93q40 53 68 93.5t49.5 78t40 78t39.5 94.5h145 q-49 -131 -133.5 -262.5t-199.5 -262.5h-105l-25 184q-3 -4 -11 -18t-18.5 -33t-23 -41t-23.5 -41t-19 -33.5t-11 -17.5h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 623,
    d: "M213 244l-136 466h178l69 -326l211 326h178l-338 -468l-51 -242h-164zM249 808l128 108h114l82 -108l-89 -36l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 531,
    d: "M-50 -111q30 1 51 4.5t37 10.5t29 18.5t27 29.5l29 37l-78 536h163l29 -388l34 56q51 82 82 161.5t51 170.5h154q-14 -48 -29 -90t-38 -89.5t-56.5 -105t-82.5 -137.5l-80 -129q-35 -57 -69 -96t-70 -63t-76 -35t-88 -11zM173 622l128 108h114l82 -108l-89 -36l-67 63 l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 623,
    d: "M213 244l-136 466h178l69 -326l211 326h178l-338 -468l-51 -242h-164zM238 780l28 129h132l-28 -129h-132zM443 780l28 129h131l-27 -129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 595,
    d: "M422 772l-106 14l77 130h144zM-10 123l435 443h-327l30 144h518l-27 -123l-419 -443h329l-30 -144h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 471,
    d: "M319 586l-106 14l77 130h144zM-19 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 595,
    d: "M-10 123l435 443h-327l30 144h518l-27 -123l-419 -443h329l-30 -144h-535zM323 779l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 471,
    d: "M-19 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421zM219 593l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 595,
    d: "M248 879l89 37l67 -63l94 63l75 -37l-128 -107h-115zM-10 123l435 443h-327l30 144h518l-27 -123l-419 -443h329l-30 -144h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 471,
    d: "M143 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM-19 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 724,
    d: "M292 -5q-69 0 -120.5 25t-85 66t-50.5 92.5t-17 104.5q0 42 8.5 72.5t16.5 49.5h493q1 8 1.5 15t0.5 14q0 66 -36 100.5t-89 34.5q-23 0 -46 -6.5t-44 -19t-38.5 -30t-27.5 -39.5l-159 52q28 42 65.5 77t81.5 59.5t94.5 38t105.5 13.5q67 0 117.5 -25t84 -65.5 t50.5 -92.5t17 -107q0 -50 -14 -101.5t-40.5 -99t-64.5 -89.5t-85 -72.5t-102 -48.5t-117 -18zM325 139q62 0 111.5 38.5t71.5 104.5h-315q-4 -15 -4 -31q0 -51 37.5 -81.5t98.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 535,
    d: "M58 -202q-38 0 -70.5 12.5t-55.5 37.5l90 109q7 -11 19 -16t26 -5q20 0 36.5 15t21.5 40l75 352h-63l26 121h63l13 61q10 49 31.5 89t50.5 68t64.5 43t75.5 15q61 0 126 -31l-54 -120q-14 7 -32 11.5t-33 4.5q-53 0 -68 -74l-15 -67h115l-26 -121h-114l-74 -348 q-9 -44 -31 -80t-53 -62t-68 -40.5t-76 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1288,
    d: "M941 879l89 37l67 -63l94 63l75 -37l-128 -107h-115zM683 123l435 443h-327l30 144h518l-27 -123l-419 -443h329l-30 -144h-535zM155 710h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254zM288 144 q50 0 91 21.5t70.5 58.5t45.5 85t16 101q0 70 -33.5 113t-99.5 43h-90l-90 -422h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1164,
    d: "M836 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM674 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421zM155 710h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254zM288 144 q50 0 91 21.5t70.5 58.5t45.5 85t16 101q0 70 -33.5 113t-99.5 43h-90l-90 -422h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1105,
    d: "M777 693l89 37l67 -63l94 63l75 -37l-128 -107h-115zM615 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421zM197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l62 291h161 l-118 -550q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-38 0 -62 15t-24 49q0 12 4 31q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5 q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1046,
    d: "M655 -11q-85 0 -137 44l63 134q7 -8 35.5 -20t69.5 -12q33 0 55.5 12.5t38.5 38.5t28 66.5t24 96.5l77 361h165l-77 -361q-17 -81 -39.5 -147.5t-60 -113.5t-96 -73t-146.5 -26zM155 710h164l-121 -566h321l-30 -144h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 835,
    d: "M488 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q20 0 37 14.5t22 40.5l113 534h160l-110 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15zM713 730h160l-31 -145h-160zM155 710h164l-121 -566h321l-30 -144h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 599,
    d: "M251 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q20 0 37 14.5t22 40.5l113 534h160l-110 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15zM476 730h160l-31 -145h-160zM126 -9q-57 0 -86 25t-29 73q0 10 1.5 20t3.5 22l127 599h160l-116 -543 q-1 -5 -1.5 -10.5t-0.5 -10.5q0 -39 38 -39q11 0 25.5 3.5t27.5 10.5l-5 -120q-32 -14 -72 -22t-73 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1212,
    d: "M821 -11q-85 0 -137 44l63 134q7 -8 35.5 -20t69.5 -12q33 0 55.5 12.5t38.5 38.5t28 66.5t24 96.5l77 361h165l-77 -361q-17 -81 -39.5 -147.5t-60 -113.5t-96 -73t-146.5 -26zM155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1002,
    d: "M654 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q20 0 37 14.5t22 40.5l113 534h160l-110 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15zM879 730h160l-31 -145h-160zM155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 864,
    d: "M516 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q20 0 37 14.5t22 40.5l113 534h160l-110 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15zM741 730h160l-31 -145h-160zM102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5 t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 733,
    d: "M277 -204q-57 8 -84.5 30.5t-27.5 51.5t24.5 59.5t73.5 59.5q-56 7 -99 33.5t-72 66.5t-44 90t-15 104t16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -74 -29.5 -144.5t-80 -128t-118 -96.5t-142.5 -50 q-83 -48 -83 -85q0 -14 13.5 -23t42.5 -10zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 590,
    d: "M209 -209q-57 8 -84.5 30.5t-27.5 51.5t24.5 59.5t74.5 59.5q-47 5 -81.5 24t-57.5 48t-34.5 66.5t-11.5 78.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -55 -19.5 -108t-55.5 -97t-86.5 -75t-112.5 -41 q-87 -50 -87 -87q0 -14 13.5 -23t42.5 -10zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1278,
    d: "M673 123l435 443h-327l30 144h518l-27 -123l-419 -443h329l-30 -144h-535zM155 710h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254zM288 144q50 0 91 21.5t70.5 58.5t45.5 85t16 101q0 70 -33.5 113 t-99.5 43h-90l-90 -422h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1160,
    d: "M669 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421zM155 710h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254zM288 144q50 0 91 21.5t70.5 58.5t45.5 85t16 101q0 70 -33.5 113 t-99.5 43h-90l-90 -422h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1105,
    d: "M615 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421zM197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l62 291h161l-118 -550q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135 q-23 -5 -39.5 -6.5t-28.5 -1.5q-38 0 -62 15t-24 49q0 12 4 31q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 704,
    d: "M506 772l-106 14l77 130h144zM481 70q-48 -38 -93.5 -56.5t-96.5 -18.5q-57 0 -104 21t-81.5 59t-53.5 91.5t-19 118.5q0 88 35.5 166.5t95 137t136 92.5t158.5 34q93 0 155.5 -41.5t82.5 -113.5l-141 -92q-13 48 -49.5 74.5t-84.5 26.5q-44 0 -83.5 -21.5t-69.5 -58 t-48 -84.5t-18 -101q0 -35 9 -65t26.5 -52t42 -34t56.5 -12q89 0 179 88l5 23h-129l25 119h265l-79 -371h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 618,
    d: "M359 586l-106 14l77 130h144zM160 -223q-81 0 -133 27t-84 78l104 87q20 -33 56.5 -52.5t81.5 -19.5q27 0 53 8t48 24.5t38 43t24 63.5l10 51q-31 -44 -78.5 -66.5t-96.5 -22.5q-41 0 -72.5 16t-53.5 44t-33.5 65.5t-11.5 81.5q0 67 24 127t65 105t95 71.5t114 26.5 q55 0 91.5 -25.5t52.5 -70.5l19 86h139l-104 -489q-13 -60 -44.5 -108t-77 -81.5t-103.5 -51.5t-123 -18zM267 125q32 0 62 20.5t53 52.5l24 110q-6 42 -31 66.5t-57 24.5q-27 0 -52.5 -15t-44.5 -39t-30.5 -54.5t-11.5 -61.5q0 -45 23.5 -74.5t64.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 641,
    d: "M499 808q23 -17 23 -49q0 -44 -33 -71l89 -688h-168l-15 159h-202l-81 -159h-169l381 687q-14 16 -14 40q0 36 20.5 59.5t55.5 32.5l66 105h144zM392 272l-20 251l-130 -251h150zM423 778q-18 0 -31.5 -11.5t-13.5 -28.5q0 -13 8.5 -21t22.5 -8q17 0 31.5 11.5t14.5 29.5 q0 12 -9 20t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM406 742l-106 14l77 130h144zM231 632q0 48 34.5 73t89.5 25q42 0 65 -17t23 -49 q0 -47 -34.5 -72t-88.5 -25q-42 0 -65.5 16.5t-23.5 48.5zM344 683q-18 0 -31.5 -11.5t-13.5 -28.5q0 -13 8.5 -21t22.5 -8q17 0 31.5 11.5t14.5 29.5q0 12 -9 20t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 932,
    d: "M667 772l-106 14l77 130h144zM484 710h494l-31 -144h-287l-28 -133h235l-30 -143h-235l-31 -146h294l-30 -144h-458l34 159h-201l-116 -159h-174zM429 303l47 224l-166 -224h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 897,
    d: "M531 586l-106 14l77 130h144zM130 -10q-33 0 -59 10.5t-45 28.5t-29 43.5t-10 55.5q0 43 20 80.5t54.5 65t81.5 43t100 15.5q30 0 56 -5.5t45 -14.5q3 14 7 27t4 26q0 29 -19.5 44.5t-60.5 15.5t-81 -14.5t-86 -43.5l-26 100q113 68 232 68q57 0 97.5 -16.5t64.5 -47.5 q38 29 84 46.5t100 17.5t95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -38 -7.5 -63t-14.5 -40h-365q-1 -6 -1.5 -11t-0.5 -12q0 -42 25 -63.5t61 -21.5q32 0 64.5 17t48.5 46l128 -38q-42 -62 -112.5 -101t-158.5 -39q-75 0 -124 28.5t-72 76.5q-24 -28 -52.5 -48t-58 -32.5 t-57.5 -18.5t-51 -6zM203 105q15 0 32.5 4.5t34 11.5t30.5 16.5t23 20.5q-1 5 -1.5 10t-0.5 11q0 11 1.5 23t3.5 26q-17 7 -37.5 11t-38.5 4q-21 0 -40.5 -6.5t-34.5 -17.5t-23.5 -26.5t-8.5 -33.5q0 -23 15.5 -38.5t44.5 -15.5zM711 310q1 5 1 9.5v11.5q0 40 -21 64.5 t-59 24.5q-42 0 -76 -30t-48 -80h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 733,
    d: "M781 710l-105 -118q23 -38 35 -82.5t12 -92.5q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36q-38 0 -70 8.5t-60 23.5l-23 -26h-176l106 119q-23 37 -34 80.5t-11 91.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q35 0 66.5 -8.5t57.5 -22.5l24 27 h176zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 26 -4 46l-270 -302q21 -10 52 -10zM201 304q0 -22 3 -43l267 298q-21 9 -48 9q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92zM508 772l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    d: "M51 73q-20 28 -30 63t-10 73q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q42 0 74.5 -10.5t58.5 -28.5l36 34h87l-80 -75q21 -29 31.5 -64.5t10.5 -74.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28q-43 0 -77 10.5t-60 30.5l-39 -36h-86zM258 125q27 0 52 13 t44.5 36.5t31 54.5t11.5 67q0 20 -5 38l-186 -189q22 -20 52 -20zM178 228q0 -18 3 -34l183 187q-20 18 -48 18q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67zM392 586l-106 14l77 130h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM433 918h118l14 -130l-85 -16zM263 918h119l13 -130l-85 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM349 730h118l14 -130l-85 -16zM179 730h119l13 -130l-85 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 641,
    d: "M337 710h149l92 -710h-168l-15 159h-202l-81 -159h-169zM392 272l-20 251l-130 -251h150zM284 769q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 634,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l18 83h161l-74 -342q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5q-39 0 -62 15.5t-23 51.5q0 10 3 28 q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5zM193 583q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84 q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 576,
    d: "M415 918h118l14 -130l-85 -16zM245 918h119l13 -130l-85 -16zM155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 558,
    d: "M372 730h118l14 -130l-85 -16zM202 730h119l13 -130l-85 -16zM232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17 t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 576,
    d: "M260 769q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 558,
    d: "M225 583q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111 q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM266 918h118l14 -130l-85 -16zM96 918h119l13 -130l-85 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 268,
    d: "M217 730h118l14 -130l-85 -16zM47 730h119l13 -130l-85 -16zM102 525h160l-112 -525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM109 769q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 268,
    d: "M60 583q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM102 525h160l-112 -525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 733,
    d: "M506 918h118l14 -130l-85 -16zM336 918h119l13 -130l-85 -16zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5 t-160 -36zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    d: "M376 730h118l14 -130l-85 -16zM206 730h119l13 -130l-85 -16zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5 t-136.5 -28zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 733,
    d: "M332 769q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5 q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    d: "M222 583q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5 t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 647,
    d: "M421 918h118l14 -130l-85 -16zM251 918h119l13 -130l-85 -16zM4 0l151 710h305q42 0 74.5 -17t55 -45t34.5 -64t12 -74q0 -37 -11.5 -73t-32 -68.5t-49 -59.5t-62.5 -45l91 -264h-185l-78 229h-93l-48 -229h-164zM383 372q15 0 30 9.5t27 26t19.5 38.5t7.5 47 q0 33 -14 53t-34 20h-131l-41 -194h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 392,
    d: "M267 730h118l14 -130l-85 -16zM97 730h119l13 -130l-85 -16zM102 525h147l-23 -106q38 53 84.5 83t91.5 30q19 0 23 -1l-30 -143q-54 -1 -101.5 -19t-76.5 -54l-67 -315h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 647,
    d: "M275 769q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM4 0l151 710h305q42 0 74.5 -17t55 -45t34.5 -64t12 -74q0 -37 -11.5 -73t-32 -68.5t-49 -59.5t-62.5 -45l91 -264h-185 l-78 229h-93l-48 -229h-164zM383 372q15 0 30 9.5t27 26t19.5 38.5t7.5 47q0 33 -14 53t-34 20h-131l-41 -194h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 392,
    d: "M127 583q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM102 525h147l-23 -106q38 53 84.5 83t91.5 30q19 0 23 -1l-30 -143q-54 -1 -101.5 -19t-76.5 -54l-67 -315h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 716,
    d: "M473 918h118l14 -130l-85 -16zM303 918h119l13 -130l-85 -16zM292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164 l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5t-140.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 606,
    d: "M364 730h118l14 -130l-85 -16zM194 730h119l13 -130l-85 -16zM139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5 q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 716,
    d: "M320 769q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50 t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5t-140.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 606,
    d: "M209 583q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83zM139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160 l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5q-45 -52 -100 -76.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 594,
    d: "M146 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM244 -8q-75 0 -147 23t-124 65l102 143q2 -5 19.5 -19t45 -28t63.5 -25t75 -11q48 0 68 17.5t20 45.5q0 17 -11 28.5t-30.5 21t-45 18t-54.5 18.5q-72 26 -107.5 61t-35.5 94q0 64 26 115t68.5 85.5t97.5 53t113 18.5 q36 0 69 -7t62 -18t53.5 -25t44.5 -28l-100 -136q-2 4 -16.5 15t-37.5 23t-52 21t-59 9q-42 0 -65.5 -18.5t-23.5 -51.5q0 -29 31 -43.5t88 -32.5q38 -12 69.5 -26.5t54 -34.5t34.5 -47t12 -64q0 -71 -27 -120.5t-71 -80.5t-99 -45t-110 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 482,
    d: "M80 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM187 -10q-63 0 -120.5 21.5t-92.5 62.5l77 98q38 -33 78 -51t79 -18q32 0 48 13.5t16 36.5q0 17 -16.5 28.5t-57.5 24.5t-70.5 25.5t-48.5 27t-28 32t-9 40.5q0 44 19.5 81.5t52.5 64.5t77 42.5t94 15.5 q56 0 101.5 -16t83.5 -58l-82 -96q-37 31 -67 45t-60 14q-27 0 -45 -13t-18 -39q0 -17 17 -27.5t56 -21.5q86 -25 124 -54t38 -79q0 -44 -18 -81t-50.5 -63.5t-77.5 -41t-100 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 596,
    d: "M137 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM273 566h-203l30 144h569l-30 -144h-202l-121 -566h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 392,
    d: "M70 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70zM163 -10q-51 0 -84 22.5t-33 76.5q0 21 4 41l58 274h-63l27 121h62l36 167h160l-36 -167h101l-26 -121h-101l-46 -219q-1 -5 -1.5 -9t-0.5 -8q0 -17 9.5 -24.5t24.5 -7.5q16 0 36 6t37 13v-127q-36 -16 -79 -27 t-85 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 268,
    d: "M-80 -202q-38 0 -70 12.5t-55 37.5l90 109q7 -11 18.5 -16t25.5 -5q21 0 37.5 15t21.5 40l113 534h161l-111 -522q-10 -45 -32 -83t-53 -65t-68.5 -42t-77.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 584,
    d: "M223 -10q-55 0 -96 16t-68.5 44t-41 65.5t-13.5 81.5q0 28 6 58.5t16 56.5h364q1 5 1 10.5v10.5q0 42 -24.5 64t-58.5 22q-33 0 -65.5 -17t-48.5 -46l-128 39q42 61 112.5 100.5t159.5 39.5q54 0 95 -17.5t68.5 -47t41.5 -69t14 -84.5q0 -62 -24 -121t-67.5 -105 t-105.5 -73.5t-137 -27.5zM249 105q42 0 75 29.5t48 79.5h-201q-1 -5 -1 -10v-10q0 -42 21 -65.5t58 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 515,
    d: "M232 600l49 80v50h172l-126 -158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 370,
    d: "M31 622l128 108h114l82 -108l-89 -36l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 370,
    d: "M35 693l89 37l67 -63l94 63l75 -37l-128 -107h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 410,
    d: "M80 717h291l-21 -97h-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 335,
    d: "M163 653q21 0 41.5 21.5t31.5 55.5h84q-7 -32 -23 -59t-39 -46.5t-51 -30.5t-59 -11q-54 0 -84.5 30t-30.5 80q0 9 1.5 18t3.5 19h84q-3 -11 -3 -21q0 -24 12 -40t32 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 238,
    d: "M39 593l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 256,
    d: "M31 632q0 48 34.5 73t89.5 25q42 0 65 -17t23 -49q0 -47 -34.5 -72t-88.5 -25q-42 0 -65.5 16.5t-23.5 48.5zM144 683q-18 0 -31.5 -11.5t-13.5 -28.5q0 -13 8.5 -21t22.5 -8q17 0 31.5 11.5t14.5 29.5q0 12 -9 20t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 300,
    d: "M154 -204q-57 8 -84.5 30.5t-27.5 51.5q0 36 38 74t113 71l43 -22q-89 -51 -89 -88q0 -14 13.5 -23t42.5 -10l-49 -84v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 431,
    d: "M271 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44 t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 366,
    d: "M92 588l-81 12l68 130h119zM262 588l-81 12l67 130h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 366,
    d: "M208 730h118l14 -130l-85 -16zM38 730h119l13 -130l-85 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 335,
    d: "M32 583q7 32 23 59t39 46.5t51 30.5t59 11q54 0 83.5 -33t29.5 -81q0 -15 -3 -33h-84q3 16 3 30q0 47 -44 47q-26 0 -46 -17.5t-28 -59.5h-83v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 643,
    d: "M-14 126l245 584h133l244 -584v-126h-622v126zM450 144l-153 385l-149 -385h302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 823,
    d: "M40 114h158q-69 40 -108.5 106.5t-39.5 151.5q0 68 26.5 130t73 109.5t110 75.5t138.5 28q74 0 137.5 -28t110 -75.5t73 -109.5t26.5 -130q0 -85 -39.5 -151.5t-108.5 -106.5h158v-114h-317v114q33 13 60 39.5t46 61.5t29 75.5t10 81.5q0 37 -12.5 72t-36.5 63t-58.5 45 t-77.5 17q-44 0 -78.5 -17t-58.5 -45t-36.5 -63t-12.5 -72q0 -41 10 -81.5t29 -75.5t46 -61.5t61 -39.5v-114h-318v114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 618,
    d: "M101 525h160l-64 -301q-5 -25 -5 -40q0 -59 53 -59q25 0 55 17t61 59l69 324h160l-73 -345q-3 -11 -3 -19q0 -25 34 -26l-29 -135q-25 -5 -43.5 -6.5t-32.5 -1.5q-84 0 -84 64q0 2 0.5 13t3.5 22q-9 -15 -26 -32.5t-38.5 -32.5t-45.5 -25.5t-46 -10.5q-29 0 -43.5 13 t-15.5 35l-44 -251h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 725,
    d: "M525 -9q-69 0 -106 36t-37 104v255h-103v-386h-158v386h-73v136h582v-136h-89v-199q0 -60 52 -60q12 0 26 3.5t26 10.5l22 -120q-31 -14 -70 -22t-72 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 693,
    d: "M155 -204l29 137h144l-29 -137h-144zM155 710h254q69 0 120.5 -21.5t85 -58.5t50 -87.5t16.5 -108.5q0 -94 -32 -173.5t-89 -137.5t-134.5 -90.5t-167.5 -32.5h-254zM288 144q50 0 91 21.5t70.5 58.5t45.5 85t16 101q0 70 -33.5 113t-99.5 43h-90l-90 -422h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 634,
    d: "M144 -204l29 137h144l-29 -137h-144zM197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 66 23.5 126.5t62.5 106t91 72.5t109 27q51 0 87 -26t50 -70l62 291h161l-118 -550q-1 -7 -1.5 -11.5t-0.5 -9.5q0 -23 25 -24l-28 -135q-23 -5 -39.5 -6.5t-28.5 -1.5 q-38 0 -62 15t-24 49q0 12 4 31q-37 -49 -86.5 -73t-100.5 -24zM269 125q30 0 61 19.5t54 53.5l23 110q-5 40 -30 65.5t-57 25.5q-27 0 -52.5 -14.5t-45 -38t-31 -54t-11.5 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 721,
    d: "M155 710h164l-59 -275h257l59 275h164l-151 -710h-164l62 291h-257l-62 -291h-164zM179 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    d: "M145 730h160l-62 -293q37 47 87 72.5t105 25.5q36 0 59.5 -10t38 -26.5t20 -38.5t5.5 -46q0 -19 -2.5 -38.5t-6.5 -39.5l-71 -336h-160l63 295q2 11 3 20.5t1 18.5q0 31 -14 45.5t-38 14.5q-12 0 -28 -6.5t-32.5 -19t-32 -29.5t-26.5 -38l-64 -301h-160zM120 -204l29 137 h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 729,
    d: "M387 779l29 137h144l-29 -137h-144zM155 710h128l213 -417l88 417h164l-151 -710h-130l-213 406l-86 -406h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    d: "M278 593l29 137h144l-29 -137h-144zM102 525h144l-19 -88q37 47 92 72.5t121 25.5q35 0 57.5 -10t36 -26.5t19 -38.5t5.5 -46q0 -20 -2.5 -39.5t-6.5 -38.5l-71 -336h-160l63 295q4 20 4 40q0 31 -13 45t-35 14q-29 0 -65 -26t-58 -67l-64 -301h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 647,
    d: "M4 0l151 710h305q42 0 74.5 -17t55 -45t34.5 -64t12 -74q0 -37 -11.5 -73t-32 -68.5t-49 -59.5t-62.5 -45l91 -264h-185l-78 229h-93l-48 -229h-164zM383 372q15 0 30 9.5t27 26t19.5 38.5t7.5 47q0 33 -14 53t-34 20h-131l-41 -194h136zM149 -204l29 137h144l-29 -137 h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 392,
    d: "M102 525h147l-23 -106q38 53 84.5 83t91.5 30q19 0 23 -1l-30 -143q-54 -1 -101.5 -19t-76.5 -54l-67 -315h-160zM-43 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 594,
    d: "M244 -8q-75 0 -147 23t-124 65l102 143q2 -5 19.5 -19t45 -28t63.5 -25t75 -11q48 0 68 17.5t20 45.5q0 17 -11 28.5t-30.5 21t-45 18t-54.5 18.5q-72 26 -107.5 61t-35.5 94q0 64 26 115t68.5 85.5t97.5 53t113 18.5q36 0 69 -7t62 -18t53.5 -25t44.5 -28l-100 -136 q-2 4 -16.5 15t-37.5 23t-52 21t-59 9q-42 0 -65.5 -18.5t-23.5 -51.5q0 -29 31 -43.5t88 -32.5q38 -12 69.5 -26.5t54 -34.5t34.5 -47t12 -64q0 -71 -27 -120.5t-71 -80.5t-99 -45t-110 -14zM129 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 482,
    d: "M187 -10q-63 0 -120.5 21.5t-92.5 62.5l77 98q38 -33 78 -51t79 -18q32 0 48 13.5t16 36.5q0 17 -16.5 28.5t-57.5 24.5t-70.5 25.5t-48.5 27t-28 32t-9 40.5q0 44 19.5 81.5t52.5 64.5t77 42.5t94 15.5q56 0 101.5 -16t83.5 -58l-82 -96q-37 31 -67 45t-60 14 q-27 0 -45 -13t-18 -39q0 -17 17 -27.5t56 -21.5q86 -25 124 -54t38 -79q0 -44 -18 -81t-50.5 -63.5t-77.5 -41t-100 -14.5zM63 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 596,
    d: "M119 -204l29 137h144l-29 -137h-144zM273 566h-203l30 144h569l-30 -144h-202l-121 -566h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 392,
    d: "M47 -204l29 137h144l-29 -137h-144zM163 -10q-51 0 -84 22.5t-33 76.5q0 21 4 41l58 274h-63l27 121h62l36 167h160l-36 -167h101l-26 -121h-101l-46 -219q-1 -5 -1.5 -9t-0.5 -8q0 -17 9.5 -24.5t24.5 -7.5q16 0 36 6t37 13v-127q-36 -16 -79 -27t-85 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1002,
    d: "M76 710h178l52 -522l102 191l-40 330h150l18 -227l114 227h151l-183 -330l23 -191l273 522h180l-420 -710h-136l-46 278l-162 -278h-137zM504 917h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 802,
    d: "M38 525h154l51 -380q5 6 15 24.5t21.5 39.5t21 39.5t13.5 24.5l-48 252h133l18 -159q3 6 14 29.5t23.5 50t22.5 50t12 29.5h123q-27 -72 -56.5 -131t-71.5 -120l17 -93q40 53 68 93.5t49.5 78t40 78t39.5 94.5h145q-49 -131 -133.5 -262.5t-199.5 -262.5h-105l-25 184 q-3 -4 -11 -18t-18.5 -33t-23 -41t-23.5 -41t-19 -33.5t-11 -17.5h-138zM361 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1002,
    d: "M629 772l-106 14l77 130h144zM76 710h178l52 -522l102 191l-40 330h150l18 -227l114 227h151l-183 -330l23 -191l273 522h180l-420 -710h-136l-46 278l-162 -278h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 802,
    d: "M487 586l-106 14l77 130h144zM38 525h154l51 -380q5 6 15 24.5t21.5 39.5t21 39.5t13.5 24.5l-48 252h133l18 -159q3 6 14 29.5t23.5 50t22.5 50t12 29.5h123q-27 -72 -56.5 -131t-71.5 -120l17 -93q40 53 68 93.5t49.5 78t40 78t39.5 94.5h145q-49 -131 -133.5 -262.5 t-199.5 -262.5h-105l-25 184q-3 -4 -11 -18t-18.5 -33t-23 -41t-23.5 -41t-19 -33.5t-11 -17.5h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1002,
    d: "M428 780l28 129h132l-28 -129h-132zM633 780l28 129h131l-27 -129h-132zM76 710h178l52 -522l102 191l-40 330h150l18 -227l114 227h151l-183 -330l23 -191l273 522h180l-420 -710h-136l-46 278l-162 -278h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 802,
    d: "M288 593l28 129h132l-28 -129h-132zM493 593l28 129h131l-27 -129h-132zM38 525h154l51 -380q5 6 15 24.5t21.5 39.5t21 39.5t13.5 24.5l-48 252h133l18 -159q3 6 14 29.5t23.5 50t22.5 50t12 29.5h123q-27 -72 -56.5 -131t-71.5 -120l17 -93q40 53 68 93.5t49.5 78 t40 78t39.5 94.5h145q-49 -131 -133.5 -262.5t-199.5 -262.5h-105l-25 184q-3 -4 -11 -18t-18.5 -33t-23 -41t-23.5 -41t-19 -33.5t-11 -17.5h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 595,
    d: "M-10 123l435 443h-327l30 144h518l-27 -123l-419 -443h329l-30 -144h-535zM119 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 471,
    d: "M-19 96l312 318h-232l24 111h401l-21 -96l-312 -318h252l-24 -111h-421zM56 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476zM120 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 558,
    d: "M232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10 zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13zM122 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 576,
    d: "M155 710h467l-31 -144h-303l-29 -138h260l-28 -133h-260l-33 -151h312l-30 -144h-476zM459 774q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5 t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 558,
    d: "M232 -10q-51 0 -92 16.5t-69.5 45.5t-43.5 70t-15 90q0 66 26 125t72 103t107.5 69.5t132.5 25.5q91 0 142.5 -39t51.5 -111q0 -86 -78 -130t-234 -44h-26.5t-27.5 1q0 -53 19 -80t64 -27q36 0 66.5 17t49.5 47l126 -40q-21 -31 -51 -56.5t-65.5 -44t-75 -28.5t-79.5 -10 zM324 420q-45 0 -77.5 -31t-50.5 -79h36q88 0 123 15t35 46q0 23 -18.5 36t-47.5 13zM420 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5 q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 300,
    d: "M155 710h164l-151 -710h-164zM-27 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 268,
    d: "M102 525h160l-112 -525h-160zM145 730h160l-31 -145h-160zM-43 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 733,
    d: "M190 -204l29 137h144l-29 -137h-144zM301 -6q-65 0 -115 24.5t-84 66t-51.5 95t-17.5 111.5q0 54 16 106t44.5 99t67.5 87t86.5 69t100.5 45.5t109 16.5q64 0 114 -25t83.5 -66t51 -95t17.5 -111q0 -80 -34.5 -156t-93 -135.5t-134.5 -95.5t-160 -36zM333 140q52 0 93 25 t69.5 63.5t44 85.5t15.5 92q0 33 -8 62t-24 51.5t-41 35.5t-59 13q-51 0 -92.5 -24.5t-70 -62.5t-44 -85t-15.5 -92q0 -33 8 -62.5t24 -52t41 -36t59 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    d: "M123 -204l29 137h144l-29 -137h-144zM229 -10q-55 0 -96 17.5t-68 47.5t-40.5 69.5t-13.5 84.5q0 62 24 120.5t68 104.5t105.5 73.5t136.5 27.5q54 0 95 -17.5t68.5 -47.5t41 -69.5t13.5 -84.5q0 -62 -24 -120.5t-68 -104t-105.5 -73.5t-136.5 -28zM258 125q27 0 52 13 t44 36.5t30.5 54.5t11.5 67q0 47 -21.5 75t-58.5 28q-27 0 -52 -13t-44 -36.5t-30.5 -54.5t-11.5 -67q0 -47 21.5 -75t58.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 716,
    d: "M292 -6q-65 0 -110 18.5t-73.5 51t-41.5 77t-13 95.5q0 54 12 111l78 363h164l-78 -363q-9 -44 -9 -81q0 -27 5.5 -50t17.5 -40t31.5 -26.5t47.5 -9.5q38 0 68 17.5t52 46.5t37 66.5t24 76.5l77 363h164l-77 -363q-16 -74 -47.5 -138t-78.5 -112t-109.5 -75.5 t-140.5 -27.5zM176 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 606,
    d: "M139 -10q-61 0 -92 32t-31 94q0 32 9 73l72 336h159l-64 -301q-5 -25 -5 -39q0 -60 50 -60q27 0 57.5 17t61.5 59l69 324h160l-73 -345q-3 -14 -3 -21q0 -23 26 -24l-29 -135q-22 -5 -38.5 -6.5t-29.5 -1.5q-38 0 -62 15t-24 49q0 6 1.5 13.5t3.5 21.5 q-45 -52 -100 -76.5t-118 -24.5zM117 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 623,
    d: "M213 244l-136 466h178l69 -326l211 326h178l-338 -468l-51 -242h-164zM315 917h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 531,
    d: "M-50 -111q30 1 51 4.5t37 10.5t29 18.5t27 29.5l29 37l-78 536h163l29 -388l34 56q51 82 82 161.5t51 170.5h154q-14 -48 -29 -90t-38 -89.5t-56.5 -105t-82.5 -137.5l-80 -129q-35 -57 -69 -96t-70 -63t-76 -35t-88 -11zM224 730h144l22 -130l-111 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 623,
    d: "M213 244l-136 466h178l69 -326l211 326h178l-338 -468l-51 -242h-164zM469 774q-22 0 -37 7t-27.5 16t-24.5 16t-28 7t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5 q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 531,
    d: "M-50 -111q30 1 51 4.5t37 10.5t29 18.5t27 29.5l29 37l-78 536h163l29 -388l34 56q51 82 82 161.5t51 170.5h154q-14 -48 -29 -90t-38 -89.5t-56.5 -105t-82.5 -137.5l-80 -129q-35 -57 -69 -96t-70 -63t-76 -35t-88 -11zM382 588q-22 0 -37 7t-27.5 16t-24.5 16t-28 7 t-26.5 -7t-16.5 -16t-8.5 -16.5t-2.5 -8.5h-87q2 11 13.5 34.5t31.5 47.5t47.5 42t61.5 18q23 0 38 -7.5t27 -16.5t23.5 -16.5t28.5 -7.5q16 0 27.5 7.5t18.5 16.5t10.5 17t3.5 9h85q-2 -8 -13.5 -31t-32 -48t-49 -44t-63.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 583
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 889
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 595,
    d: "M32 203l31 144h488l-31 -144h-488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 900,
    d: "M32 203l31 144h793l-31 -144h-793z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 267,
    d: "M285 730l-50 -126h45l-31 -147h-164l31 150l64 123h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 256,
    d: "M109 501l50 126h-45l31 147h164l-31 -150l-64 -123h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 273,
    d: "M-17 -140l53 140h-45l35 163h164l-35 -167l-67 -136h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 468,
    d: "M285 730l-50 -126h45l-31 -147h-164l31 150l64 123h105zM486 730l-50 -126h45l-31 -147h-164l31 150l64 123h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 563,
    d: "M310 501l50 126h-45l31 147h164l-31 -150l-64 -123h-105zM109 501l50 126h-45l31 147h164l-31 -150l-64 -123h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 478,
    d: "M-17 -140l53 140h-45l35 163h164l-35 -167l-67 -136h-105zM188 -140l54 140h-46l35 163h164l-35 -167l-67 -136h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 471,
    d: "M68 -130l70 329h-125l31 144h125l92 432h152l-93 -432h125l-30 -144h-125l-70 -329h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 489,
    d: "M79 -130l44 209h-125l30 144h126l24 112h-126l30 144h126l63 296h152l-63 -296h124l-30 -144h-125l-24 -112h125l-31 -144h-125l-44 -209h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 358,
    d: "M298 371q0 -26 -11 -49.5t-30 -41.5t-43 -28.5t-49 -10.5q-38 0 -61.5 26.5t-23.5 64.5q0 26 11.5 49.5t30 41t42 28t48.5 10.5q39 0 62.5 -26t23.5 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 649,
    d: "M-9 0l34 163h131l-35 -163h-130zM196 0l35 163h130l-34 -163h-131zM402 0l34 163h131l-35 -163h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1168,
    d: "M228 411q-31 0 -56 10t-43 27.5t-27.5 41t-9.5 50.5q0 36 17 69t44.5 57.5t63 39t73.5 14.5q31 0 56.5 -10t43.5 -27.5t27.5 -41t9.5 -50.5q0 -36 -17 -69t-44.5 -57.5t-63.5 -39t-74 -14.5zM244 489q12 0 25 8t23.5 21t17 30t6.5 36q0 25 -11 41.5t-31 16.5 q-12 0 -25 -8t-23 -21t-16.5 -30t-6.5 -36q0 -24 11 -41t30 -17zM531 -10q-32 0 -57 10t-43 27.5t-27.5 41t-9.5 50.5q0 36 17 69t44.5 57.5t63.5 39t74 14.5q31 0 56 -10t43 -27.5t27.5 -41t9.5 -50.5q0 -36 -16.5 -69t-44.5 -57.5t-63.5 -39t-73.5 -14.5zM546 68 q13 0 25.5 8t23 21t17 30.5t6.5 36.5q0 23 -11 40t-30 17q-13 0 -25.5 -8t-23 -21t-17 -30t-6.5 -36q0 -25 11 -41.5t30 -16.5zM908 -10q-32 0 -57.5 10t-43.5 27.5t-27.5 40.5t-9.5 50q0 37 17 69.5t44.5 57.5t63.5 39.5t74 14.5q31 0 56.5 -10t43.5 -27.5t27.5 -41 t9.5 -50.5q0 -36 -17 -69t-44.5 -57.5t-63.5 -39t-73 -14.5zM923 68q13 0 25.5 8t23 21t17 30.5t6.5 36.5q0 23 -11 40t-30 17q-13 0 -25.5 -8t-23 -21t-17 -30t-6.5 -36q0 -25 11 -41.5t30 -16.5zM56 56l338 324l313 339l58 -64l-326 -315l-325 -349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 347,
    d: "M32 293l299 193l-27 -129l-154 -98l113 -91l-27 -129l-221 178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 347,
    d: "M296 217l-296 -178l27 129l152 91l-112 98l27 129l218 -193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 219,
    d: "M-233 56l337 324l314 339l58 -64l-327 -315l-325 -349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 482,
    d: "M258 381q-45 0 -77 16.5t-52.5 42.5t-30.5 58t-10 64q0 44 20.5 89.5t56 82t83.5 60t103 23.5q45 0 77 -16.5t52.5 -43t30 -59t9.5 -64.5q0 -44 -20 -88.5t-55.5 -81.5t-83.5 -60t-103 -23zM185 575q0 -18 5 -36.5t16.5 -32.5t29 -23t42.5 -9q35 0 62 15t45.5 37.5t28 48 t9.5 47.5q0 19 -5.5 37.5t-16.5 32.5t-28.5 23t-41.5 9q-35 0 -62.5 -15t-46 -37t-28 -48.5t-9.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 406,
    d: "M246 388l18 88h-206l20 91l288 251h64l-54 -251h60l-20 -91h-59l-19 -88h-92zM165 567h123l29 139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 388,
    d: "M279 668q61 0 97.5 -32.5t36.5 -83.5q0 -37 -17 -68t-46.5 -54t-68.5 -36t-84 -13q-51 0 -89.5 19t-54.5 52l68 63q14 -20 40 -32t61 -12q19 0 36.5 4.5t30.5 13.5t21 23t8 33q0 28 -19.5 40.5t-40.5 12.5q-23 0 -49.5 -12t-40.5 -32h-80q12 31 27 65t30 68.5t29.5 68 t25.5 62.5h239l-20 -93h-172l-34 -71q10 5 26 9.5t40 4.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 421,
    d: "M445 550q0 -35 -17.5 -66.5t-47 -55t-68.5 -37.5t-82 -14q-69 0 -105.5 40.5t-36.5 113.5q0 61 18 113.5t51 91t78.5 60t100.5 21.5q45 0 80 -15.5t55 -46.5l-67 -65q-12 18 -36.5 28t-54.5 10q-45 0 -77.5 -23t-43.5 -66q19 16 49 23.5t56 7.5q34 0 61.5 -9t46.5 -25.5 t29.5 -38.5t10.5 -47zM250 463q20 0 39 6t33.5 16t23.5 23t9 27q0 23 -22 38.5t-56 15.5q-21 0 -40 -5.5t-33.5 -15t-23 -22t-8.5 -26.5q0 -23 22.5 -40t55.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 391,
    d: "M335 725h-222l20 93h366l-333 -430h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 414,
    d: "M432 532q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-76.5 -11.5q-33 0 -61 9t-48 24.5t-31.5 37t-11.5 46.5q0 24 8 42t22 32.5t32.5 25t38.5 19.5q-20 9 -33 25.5t-13 41.5q0 29 17.5 53.5t45 42t61 27.5t64.5 10q26 0 51.5 -7.5t45 -21t31.5 -33t12 -42.5 q0 -35 -24 -58.5t-57 -37.5q26 -14 41.5 -35t15.5 -50zM339 530q0 21 -22.5 33t-51.5 12q-18 0 -35.5 -4t-30.5 -11.5t-21 -17.5t-8 -22q0 -21 23 -33.5t52 -12.5q17 0 34 4t30.5 11.5t21.5 18t8 22.5zM220 685q0 -16 19 -25t42 -9q13 0 27 3t25.5 8.5t19 13.5t7.5 18 q0 15 -18.5 24t-44.5 9q-29 0 -53 -11t-24 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 422,
    d: "M102 644q0 35 17.5 66.5t47 55t68.5 37.5t82 14q68 0 105 -41t37 -113q0 -62 -18 -114t-50.5 -90.5t-78.5 -60t-101 -21.5q-45 0 -80 16t-55 47l67 65q12 -19 36 -29.5t54 -10.5q46 0 78.5 24t42.5 66q-18 -15 -48 -23t-57 -8q-68 0 -107.5 34t-39.5 86zM297 731 q-20 0 -38.5 -6t-33 -16t-23.5 -23t-9 -27q0 -23 22 -38.5t56 -15.5q20 0 38.5 5.5t33 15t23.5 22t9 26.5q0 23 -22 40t-56 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 482,
    d: "M158 -93q-45 0 -77 16.5t-53 42.5t-31 58t-10 64q0 44 20.5 89.5t56 82t83.5 60t104 23.5q44 0 76 -16.5t52.5 -43t30.5 -59t10 -64.5q0 -44 -20 -88.5t-55.5 -81.5t-83.5 -60t-103 -23zM84 101q0 -18 5.5 -36.5t17 -32.5t29 -23t42.5 -9q35 0 62 15t45.5 37t28 48 t9.5 48q0 19 -5.5 37t-17 32.5t-29 23.5t-41.5 9q-35 0 -62.5 -15t-46 -37.5t-28 -48.5t-9.5 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 339,
    d: "M259 4l-19 -91h-277l20 91h95l52 243q-8 -7 -22.5 -16t-32 -17t-35.5 -13.5t-32 -5.5l19 93q18 0 39.5 9t40.5 19.5t31.5 20t12.5 10.5h94l-73 -343h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 420,
    d: "M-54 -87q9 42 21.5 73t32 54.5t48 41.5t68.5 34q27 10 52.5 20t46 21.5t33 26t12.5 35.5q0 20 -17.5 29t-47.5 9q-38 0 -70.5 -15t-54.5 -32l-44 69q12 12 31.5 24.5t45.5 22t57.5 16t67.5 6.5q69 0 104 -28.5t35 -81.5q0 -38 -13.5 -66t-35.5 -47.5t-49 -32t-55 -20.5 q-86 -26 -95 -68h202l-20 -91h-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 398,
    d: "M101 -93q-60 0 -98 19t-46 57l63 70q1 -4 7 -12.5t18 -17.5t30 -15.5t44 -6.5q39 0 69 12t30 37q0 23 -34 33.5t-96 10.5h-24l18 85h23q30 0 55 3t43.5 9t29 15.5t10.5 23.5q0 9 -6 15t-15.5 9.5t-20.5 5.5t-21 2q-38 0 -65.5 -13t-50.5 -34l-42 76q15 14 35 24.5t43 18 t48 11.5t49 4q33 0 60 -8t46.5 -21.5t30.5 -32.5t11 -41q0 -41 -31 -68.5t-83 -35.5q39 -6 60 -32t21 -60q0 -38 -19 -65t-49 -44t-68 -25.5t-75 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 405,
    d: "M145 -86l18 88h-206l19 91l289 251h63l-53 -251h60l-20 -91h-59l-19 -88h-92zM64 93h122l30 138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 389,
    d: "M179 193q61 0 98 -32t37 -83q0 -37 -17 -68t-46.5 -54t-69 -36t-83.5 -13q-52 0 -90 19t-55 51l68 64q15 -20 40.5 -32t60.5 -12q19 0 36.5 4.5t30.5 13.5t21 23t8 33q0 28 -19.5 40.5t-40.5 12.5q-23 0 -49.5 -12t-40.5 -32h-80q12 31 27 65t30 68.5t29.5 68t26.5 62.5 h238l-19 -93h-173l-34 -71q10 5 26 9t40 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 421,
    d: "M345 80q0 -35 -17.5 -66.5t-47 -55t-68.5 -37.5t-82 -14q-68 0 -105 40.5t-37 112.5q0 62 18 114.5t51 91t78.5 60t100.5 21.5q45 0 80 -16t55 -46l-67 -66q-12 19 -36.5 29t-54.5 10q-45 0 -77.5 -23t-42.5 -66q18 15 48 22.5t56 7.5q69 0 108.5 -34t39.5 -85zM150 -7 q20 0 39 6t33.5 15.5t23.5 22.5t9 28q0 23 -22 38.5t-56 15.5q-21 0 -40 -5.5t-33.5 -15t-23 -22t-8.5 -27.5q0 -23 22.5 -39.5t55.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 390,
    d: "M234 251h-222l20 93h367l-334 -430h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 416,
    d: "M332 58q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-76.5 -11.5q-33 0 -61 9t-48 24.5t-31.5 37t-11.5 46.5q0 24 8 42t22 32.5t32.5 25t38.5 19.5q-19 9 -32.5 25.5t-13.5 41.5q0 29 17.5 53.5t45 42t61 27.5t64.5 10q26 0 51.5 -7.5t45 -21t31.5 -33t12 -42.5 q0 -35 -24 -58.5t-57 -37.5q26 -14 41.5 -35t15.5 -50zM239 56q0 21 -22.5 33t-51.5 12q-18 0 -35.5 -4t-30.5 -11.5t-21 -18t-8 -22.5q0 -20 23 -32.5t52 -12.5q17 0 34 4t30.5 11.5t21.5 18t8 22.5zM120 211q0 -16 19 -25t42 -9q13 0 27 3t25.5 8.5t19 13t7.5 17.5 q0 16 -18.5 25t-44.5 9q-29 0 -53 -11t-24 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 421,
    d: "M2 173q0 36 17.5 67.5t47 55t68.5 37.5t82 14q69 0 105.5 -41t36.5 -113q0 -62 -18 -114t-50.5 -90.5t-78.5 -60t-101 -21.5q-45 0 -80 16t-55 46l67 65q12 -18 36 -28.5t55 -10.5q45 0 77.5 23.5t42.5 66.5q-18 -16 -48 -24t-57 -8q-34 0 -61 9t-46 25.5t-29.5 38 t-10.5 47.5zM197 261q-20 0 -38.5 -6t-33 -16t-23.5 -23t-9 -27q0 -23 22 -38.5t56 -15.5q20 0 38.5 5.5t33 15t23.5 22t9 26.5q0 23 -22 40t-56 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 555,
    d: "M128 11q-57 27 -85.5 80.5t-28.5 119.5q0 49 15.5 96t44.5 88t70 72.5t92 48.5l27 129h72l-24 -112q9 1 18.5 1.5t19.5 0.5h9.5t9.5 -1l24 111h72l-27 -124q48 -16 77 -48.5t42 -76.5l-166 -47q-19 50 -71 50q-27 0 -51.5 -13t-44 -35.5t-31 -53.5t-11.5 -68 q0 -47 22 -75.5t58 -28.5q26 0 51 14.5t42 37.5l146 -48q-30 -44 -74 -76.5t-99 -49.5l-26 -123h-72l24 111q-5 -1 -10 -1h-10q-19 0 -37 3l-24 -113h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 583,
    d: "M38 0l19 91h-68l23 105h68l109 514h460l-32 -144h-294l-33 -153h243l-29 -133h-242l-18 -84h102l-22 -105h-103l-19 -91h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 533,
    d: "M71 445h62q-2 14 -3.5 27.5t-1.5 27.5q0 45 21 84t56 68.5t80.5 46t93.5 16.5q61 0 110 -27.5t78 -77.5l-103 -98q-8 16 -21 29.5t-28 23.5t-32 15.5t-33 5.5q-35 0 -58.5 -25t-23.5 -63q0 -13 2 -26t5 -27h154l-21 -100h-117q1 -5 1 -15q0 -6 -0.5 -12t-0.5 -12h109 l-22 -100h-124q-25 -39 -74 -83q23 8 41.5 11t34.5 3q32 0 61 -8t61 -8q17 0 32 3.5t36 10.5l13 -118q-25 -14 -57.5 -23t-60.5 -9q-22 0 -43.5 5t-44 10.5t-45 10.5t-46.5 5q-26 0 -63 -7t-73 -18l-8 114q62 42 99 101h-97l22 100h109q0 2 0.5 4.5t0.5 4.5q0 8 -0.5 15 t-1.5 15h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 827,
    d: "M812 416h-77l-29 -137h77l-20 -100h-78l-38 -179h-132l-94 179h-166l-38 -179h-164l38 179h-79l22 100h78l29 137h-78l21 100h78l41 194h129l98 -194h162l41 194h165l-41 -194h77zM276 279h93l-66 127zM544 293l26 123h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1104,
    d: "M32 262h170l-16 98h-133l21 100h96l-41 250h177l25 -250h119l-31 249h151l18 -227l114 227h152l-138 -249h120l131 250h178l-147 -250h99l-21 -100h-137l-58 -98h174l-21 -100h-212l-95 -162h-138l-45 278l-162 -278h-137l-27 162h-208zM684 262h48l51 98h-110zM351 262 h47l52 98h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 765,
    d: "M145 452q24 53 62 100.5t88 83.5t110 57t128 21q96 0 157 -43t81 -112l-145 -88q-5 28 -18 46.5t-30.5 30t-38.5 16t-41 4.5q-62 0 -107.5 -33.5t-73.5 -82.5h207l-53 -86h-187q-3 -12 -5 -24.5t-2 -23.5h190l-53 -86h-125q14 -41 44 -66.5t76 -25.5q20 0 43 5.5t45.5 17 t43 30t35.5 45.5l118 -79q-24 -39 -61 -70t-80.5 -52t-90 -32t-88.5 -11q-54 0 -98 19t-76.5 51.5t-53.5 76t-30 91.5h-96l53 86h38q1 24 6 48h-64l53 86h39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 539,
    d: "M530 442h-94q-17 -57 -59.5 -104.5t-100.5 -73.5l113 -264h-185l-145 358h130q23 0 45.5 23.5t34.5 60.5h-199l22 100h181q-6 18 -17 28.5t-24 10.5h-132l27 129h460l-22 -100h-141q16 -33 20 -68h107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 345,
    d: "M184 -7q-59 0 -92 29t-33 81v507q0 28 11.5 51.5t31.5 41t47.5 27.5t59.5 10q63 0 101.5 -36t38.5 -94q0 -42 -15.5 -96t-41 -109t-58.5 -105.5t-68 -85.5v-51q0 -29 14 -45.5t39 -16.5q10 0 24 3.5t26 8.5l20 -99q-22 -9 -52 -15t-53 -6zM249 576q0 67 -39 67 q-20 0 -32 -17t-12 -44v-228q16 25 31.5 54.5t26.5 59.5t18 58t7 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1092,
    d: "M256 406l-86 -406h-164l151 710h127l214 -417l88 417h164l-151 -710h-131zM908 336q-36 0 -63 12t-45 32.5t-27 48t-9 57.5q0 43 16 84.5t45.5 73t71 51t92.5 19.5q36 0 63.5 -12t45.5 -32.5t27 -47.5t9 -58q0 -43 -16 -84t-45.5 -73t-71.5 -51.5t-93 -19.5zM879 500 q0 -30 13.5 -48.5t36.5 -18.5q17 0 33 9t28.5 25t20 37t7.5 45q0 31 -13.5 49.5t-36.5 18.5q-17 0 -33 -9t-28.5 -25t-20 -37.5t-7.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 792,
    d: "M665 710h154l-64 -303h-102l37 174l-80 -132h-82l-24 132l-37 -174h-102l65 303h153l10 -145zM328 610q-23 14 -42.5 21.5t-40.5 7.5q-17 0 -26.5 -4.5t-9.5 -14.5q0 -8 9.5 -13t37.5 -12q51 -14 74 -31.5t23 -48.5q0 -54 -41 -84t-106 -30q-38 0 -76.5 11t-62.5 28 l54 74q23 -16 48.5 -25.5t51.5 -9.5q36 0 36 17q0 8 -11 13t-40 13q-48 13 -69.5 30t-21.5 46q0 25 11.5 47t31.5 37.5t47 24.5t57 9q29 0 59 -9t59 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 841,
    d: "M406 610h-90l-43 -203h-102l43 203h-90l22 102h282zM471 710h154l10 -145l72 145h154l-64 -303h-103l38 174l-80 -132h-82l-24 132l-37 -174h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 823,
    d: "M40 115h158q-69 39 -108.5 105.5t-39.5 151.5q0 68 26.5 130t73 109.5t110 75.5t138.5 28q74 0 137.5 -28t110 -75.5t73 -109.5t26.5 -130q0 -85 -39.5 -151.5t-108.5 -105.5h158v-115h-317v115q33 13 60 39.5t46 61t29 75t10 81.5q0 37 -12.5 72t-36.5 63t-58.5 45 t-77.5 17q-44 0 -78.5 -17t-58.5 -45t-36.5 -63t-12.5 -72q0 -41 10 -81.5t29 -75t46 -61t61 -39.5v-115h-318v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 622,
    d: "M308 41q72 0 121.5 21t78.5 50l33 -39q-38 -35 -95 -59t-138 -24q-63 0 -115 22t-88.5 59t-56.5 86t-20 103q0 56 20.5 106t57 87.5t88 59.5t114.5 22t115 -23t89 -62.5t57.5 -93.5t20.5 -115h-427v-137q26 -28 64.5 -45.5t80.5 -17.5zM308 483q-42 0 -80.5 -18.5 t-64.5 -54.5v-115h293v114q-27 37 -65.5 55.5t-82.5 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 871,
    d: "M70 56l337 324l314 339l58 -64l-327 -315l-325 -349zM306 389l-19 -92h-232l20 92h73l52 243q-7 -7 -19.5 -16t-26.5 -17t-29 -13.5t-26 -5.5l20 93q15 0 32.5 9t32.5 19.5t25.5 19.5t10.5 10h95l-74 -342h65zM588 -6q-60 0 -98 19t-46 57l64 70q1 -4 6.5 -12.5 t17.5 -17.5t30 -15.5t44 -6.5q40 0 69.5 12t29.5 37q0 23 -34 33.5t-96 10.5h-24l18 85h23q60 0 99 11.5t39 39.5q0 9 -6 15t-15.5 9.5t-20.5 5.5t-21 2q-38 0 -65 -13t-51 -34l-42 76q15 14 35 25t43 18.5t48 11t49 3.5q67 0 107.5 -29t40.5 -74q0 -41 -31 -68.5t-83 -35.5 q40 -6 60.5 -32t20.5 -60q0 -38 -19 -65t-49 -44t-67.5 -25.5t-75.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 891,
    d: "M605 -6q-60 0 -98 19t-46 57l64 70q1 -4 6.5 -12.5t17.5 -17.5t30 -15.5t44 -6.5q40 0 69.5 12t29.5 37q0 23 -34 33.5t-96 10.5h-24l18 85h23q60 0 99 11.5t39 39.5q0 9 -6 15t-15.5 9.5t-20.5 5.5t-21 2q-38 0 -65 -13t-51 -34l-34 62l-351 -373l-57 65l337 324 l314 339l58 -64l-248 -240q26 11 55.5 16t58.5 5q67 0 107.5 -29t40.5 -74q0 -41 -31 -68.5t-83 -35.5q40 -6 60.5 -32t20.5 -60q0 -38 -19 -65t-49 -44t-67.5 -25.5t-75.5 -8.5zM37 296q8 42 20 73t31 55t46 42t66 34q26 11 51 20.5t44.5 20.5t31.5 25.5t12 35.5 q0 20 -16.5 29t-45.5 9q-37 0 -68.5 -14.5t-52.5 -31.5l-42 68q11 12 30 24.5t44 22t55.5 16t64.5 6.5q66 0 100.5 -28.5t34.5 -81.5q0 -38 -13 -65.5t-34 -47t-47.5 -32.5t-53.5 -21q-83 -26 -92 -68h180l-19 -91h-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 877,
    d: "M82 56l337 324l314 339l58 -64l-327 -315l-325 -349zM306 389l-19 -92h-232l20 92h73l52 243q-7 -7 -19.5 -16t-26.5 -17t-29 -13.5t-26 -5.5l20 93q15 0 32.5 9t32.5 19.5t25.5 19.5t10.5 10h95l-74 -342h65zM599 -6q-33 0 -61 9t-48 24.5t-31.5 37t-11.5 46.5 q0 24 8.5 42t22.5 32.5t32.5 25t38.5 19.5q-20 9 -33.5 25.5t-13.5 41.5q0 29 17.5 53.5t45.5 42t61 27.5t65 10q26 0 51.5 -7.5t45 -21t31.5 -33t12 -42.5q0 -35 -24 -58.5t-58 -37.5q26 -14 42 -35t16 -50q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-77.5 -11.5zM619 87 q17 0 34 4t30.5 11.5t21.5 18t8 22.5q0 21 -22 33t-52 12q-18 0 -35 -4t-30 -11.5t-21 -18t-8 -22.5q0 -20 22.5 -32.5t51.5 -12.5zM656 264q13 0 27 3t25 8.5t18.5 13.5t7.5 18q0 15 -18 24t-44 9q-30 0 -54 -11t-24 -31q0 -16 19.5 -25t42.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 889,
    d: "M193 289q-60 0 -98 19t-46 57l64 70q1 -4 7 -12.5t17.5 -17.5t29.5 -15.5t44 -6.5q40 0 70 12t30 37q0 24 -34.5 34t-96.5 10h-23l17 85h23q60 0 99 12t39 39q0 9 -6 15.5t-15.5 10t-20.5 5.5t-21 2q-37 0 -64.5 -13t-51.5 -34l-42 75q15 14 35 25t43 18.5t48.5 11 t49.5 3.5q33 0 60 -8t46.5 -21.5t30 -32t10.5 -40.5q0 -42 -31 -69.5t-83 -35.5q40 -6 60.5 -32t20.5 -60q0 -38 -19 -65t-49 -44t-67.5 -25.5t-75.5 -8.5zM112 56l337 324l314 339l58 -64l-327 -315l-325 -349zM609 -6q-33 0 -61 9t-48 24.5t-31.5 37t-11.5 46.5 q0 24 8.5 42t22.5 32.5t32.5 25t38.5 19.5q-20 9 -33.5 25.5t-13.5 41.5q0 29 17.5 53.5t45.5 42t61 27.5t65 10q26 0 51.5 -7.5t45 -21t31.5 -33t12 -42.5q0 -35 -24 -58.5t-58 -37.5q26 -14 42 -35t16 -50q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-77.5 -11.5zM629 87 q17 0 34 4t30.5 11.5t21.5 18t8 22.5q0 21 -22 33t-52 12q-18 0 -35 -4t-30 -11.5t-21 -18t-8 -22.5q0 -20 22.5 -32.5t51.5 -12.5zM666 264q13 0 27 3t25 8.5t18.5 13.5t7.5 18q0 15 -18 24t-44 9q-30 0 -54 -11t-24 -31q0 -16 19.5 -25t42.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 899,
    d: "M271 580q61 0 98 -32t37 -83q0 -37 -17 -68t-46.5 -54t-69 -36t-84.5 -13q-51 0 -89 19t-54 52l67 63q15 -20 40.5 -32t60.5 -12q39 0 68 18t29 56q0 28 -20 40.5t-41 12.5q-23 0 -49 -12t-41 -32h-80q12 31 27 65t30.5 68.5t30 68t25.5 62.5h238l-19 -93h-173l-34 -71 q10 5 26.5 9t39.5 4zM111 56l337 324l314 339l58 -64l-327 -315l-325 -349zM619 -6q-33 0 -61 9t-48 24.5t-31.5 37t-11.5 46.5q0 24 8.5 42t22.5 32.5t32.5 25t38.5 19.5q-20 9 -33.5 25.5t-13.5 41.5q0 29 17.5 53.5t45.5 42t61 27.5t65 10q26 0 51.5 -7.5t45 -21 t31.5 -33t12 -42.5q0 -35 -24 -58.5t-58 -37.5q26 -14 42 -35t16 -50q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-77.5 -11.5zM639 87q17 0 34 4t30.5 11.5t21.5 18t8 22.5q0 21 -22 33t-52 12q-18 0 -35 -4t-30 -11.5t-21 -18t-8 -22.5q0 -20 22.5 -32.5t51.5 -12.5zM676 264 q13 0 27 3t25 8.5t18.5 13.5t7.5 18q0 15 -18 24t-44 9q-30 0 -54 -11t-24 -31q0 -16 19.5 -25t42.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 867,
    d: "M41 56l337 324l314 339l58 -64l-327 -315l-325 -349zM590 -6q-33 0 -61 9t-48 24.5t-31.5 37t-11.5 46.5q0 24 8.5 42t22.5 32.5t32.5 25t38.5 19.5q-20 9 -33.5 25.5t-13.5 41.5q0 29 17.5 53.5t45.5 42t61 27.5t65 10q26 0 51.5 -7.5t45 -21t31.5 -33t12 -42.5 q0 -35 -24 -58.5t-58 -37.5q26 -14 42 -35t16 -50q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-77.5 -11.5zM610 87q17 0 34 4t30.5 11.5t21.5 18t8 22.5q0 21 -22 33t-52 12q-18 0 -35 -4t-30 -11.5t-21 -18t-8 -22.5q0 -20 22.5 -32.5t51.5 -12.5zM647 264q13 0 27 3t25 8.5 t18.5 13.5t7.5 18q0 15 -18 24t-44 9q-30 0 -54 -11t-24 -31q0 -16 19.5 -25t42.5 -9zM333 638h-222l19 93h367l-334 -430h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 576,
    d: "M256 -10q-52 0 -95.5 16t-75 44.5t-49.5 67.5t-18 84q0 51 22 94.5t58 75.5t83.5 50t98.5 18q82 0 118 -51q0 102 -27 148.5t-85 46.5q-26 0 -55.5 -9t-48.5 -25l-87 92q42 35 93.5 54.5t109.5 19.5q118 0 182 -83.5t64 -248.5q0 -92 -20.5 -165t-58 -124t-90.5 -78 t-119 -27zM266 110q22 0 42 9.5t36 25.5t25.5 37t9.5 44q0 41 -27.5 68t-69.5 27q-23 0 -43 -9t-35 -24t-24 -35t-9 -43q0 -21 7.5 -39.5t20 -32t30 -21t37.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 670,
    d: "M623 126v-126h-622v126l245 584h133zM466 144l-153 385l-149 -385h302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 762,
    d: "M495 574h-190v-664h-155v664h-80v136h661v-136h-80v-664h-156v664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 629,
    d: "M568 590h-307v-4l175 -217l-188 -229v-4h324v-136h-503v107l209 249l-202 249v105h492v-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 549,
    d: "M79 277v127h404v-127h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 611,
    d: "M-63 67l685 652l75 -75l-685 -653z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 238,
    d: "M40 240l35 166h131l-35 -166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 530,
    d: "M14 386h221l70 -274l112 678h140l-152 -790h-200l-80 276h-111v110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 739,
    d: "M226 545q31 0 54.5 -7t41.5 -18.5t32 -27t26 -32.5q12 17 26 32.5t32 27t41.5 18.5t54.5 7q39 0 71 -15.5t54.5 -42t35 -61.5t12.5 -75t-13.5 -75t-36.5 -61.5t-55 -41.5t-69 -15q-59 0 -93.5 22.5t-57.5 53.5q-11 -15 -25 -29t-32.5 -24.5t-42.5 -16.5t-56 -6 q-33 0 -64.5 15.5t-55.5 42t-39 61.5t-15 75t13.5 75t36.5 61.5t55 41.5t69 15zM240 277q35 0 54.5 21.5t36.5 51.5q-17 31 -36.5 53t-54.5 22q-25 0 -47 -17t-22 -56q0 -40 22 -57.5t47 -17.5zM520 277q25 0 46.5 17.5t21.5 57.5q0 39 -21.5 56t-46.5 17q-37 0 -56 -23.5 t-33 -55.5q15 -29 34.5 -49t54.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 386,
    d: "M106 586q0 6 -1 23.5t-2 36t-1.5 34t-0.5 17.5q0 59 35.5 91t101.5 32q33 0 72 -8t71 -22l-25 -117q-11 6 -23.5 10t-22.5 4q-23 0 -36.5 -12.5t-13.5 -36.5q0 -2 0.5 -12.5t1.5 -24t1.5 -26t0.5 -17.5l27 -488q0 -5 1 -22t2 -36t1.5 -34t0.5 -16q0 -63 -35.5 -96 t-101.5 -33q-33 0 -72 8t-70 22l24 117q12 -6 24 -10t23 -4q49 0 49 55l-0.5 11.5t-1.5 26t-1.5 27.5t-0.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 462,
    d: "M407 370q-15 -30 -43 -55.5t-71 -25.5q-23 0 -40.5 7t-32.5 16t-29.5 16t-30.5 7q-18 0 -27.5 -7t-14.5 -17l-74 44q14 29 41 53t69 24q23 0 40 -7.5t32 -17t29 -17t32 -7.5q20 0 31 8t17 19zM407 199q-8 -14 -18.5 -28.5t-24.5 -25.5t-32 -18t-39 -7q-23 0 -40.5 7.5 t-32.5 16t-29.5 16t-30.5 7.5q-18 0 -27.5 -7.5t-14.5 -16.5l-74 44q14 29 41 52.5t69 23.5q23 0 40 -7.5t32 -16.5t29 -16.5t32 -7.5q20 0 31 7.5t17 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 469,
    d: "M69 421h192l63 128l57 -31l-48 -97h54v-102h-104l-42 -86h146v-102h-196l-60 -123l-57 29l46 94h-51v102h101l42 86h-143v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 486,
    d: "M49 16v127h366v-127h-366zM51 462l362 167v-154l-199 -68l199 -62v-154l-362 153v118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 516,
    d: "M83 143h366v-127h-366v127zM85 345l199 62l-199 68v154l362 -167v-118l-362 -153v154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 589,
    d: "M398 729l186 -364l-186 -366h-179l-186 366l186 364h179zM441 353l-134 266l-124 -245l133 -267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 215,
    d: "M31 -213l45 67h-47l21 99h133l-21 -99l-61 -67h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 852,
    d: "M191 -10q-31 0 -63.5 5t-62.5 14t-56 21t-45 26l82 109q42 -30 83 -46t80 -16q32 0 52 12.5t20 35.5q0 11 -4.5 18t-15 13t-26.5 11t-39 12q-38 11 -66.5 22t-47 25t-27.5 33.5t-9 47.5q0 44 20.5 81t53.5 64t74.5 42t82.5 15q11 0 26.5 -1.5t32 -5t32.5 -9.5t29 -15 q-4 11 -5.5 24.5t-1.5 25.5q0 36 12.5 68.5t40 57.5t71 39.5t105.5 14.5q43 0 71.5 -7.5t45.5 -21t24.5 -33.5t7.5 -45q0 -20 -4 -46.5t-11 -55.5h101l-25 -121h-101l-46 -219q-2 -5 -2 -8.5v-5.5q0 -20 8.5 -27.5t24.5 -7.5q17 0 36.5 6t36.5 13v-127q-36 -14 -79.5 -26 t-84.5 -12q-50 0 -83 22.5t-33 76.5q0 10 1 22t4 25l57 268h-63l26 121h62q12 57 12 88q0 28 -11 40t-38 12q-48 0 -74 -32t-26 -78q0 -23 6 -45.5t14 -34.5l-81 -101q-40 28 -71.5 39t-58.5 11q-30 0 -50.5 -13t-20.5 -39q0 -24 21 -33.5t64 -20.5q42 -11 71.5 -22.5 t48 -26.5t26.5 -34.5t8 -46.5q0 -44 -18.5 -80.5t-50.5 -62.5t-76.5 -40.5t-96.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 576,
    d: "M289 563h116l109 -563h-151l-20 118h-181l-69 -118h-154zM337 243l-27 146l-91 -146h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 583,
    d: "M118 563h331q27 0 47 -10t33.5 -26.5t20 -38t6.5 -44.5t-8 -46.5t-22.5 -44t-36 -37.5t-48.5 -27q39 -12 61 -40.5t22 -72.5q0 -46 -20 -79t-53 -54.5t-76 -32t-89 -10.5h-288zM311 121q28 0 49 17t21 46q0 19 -11 31.5t-30 12.5h-150l-23 -107h144zM341 341 q25 0 45 13.5t20 47.5q0 20 -11.5 29t-28.5 9h-131l-21 -99h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 570,
    d: "M248 -5q-54 0 -97 20.5t-72 54.5t-44.5 77.5t-15.5 90.5q0 58 26.5 116.5t73.5 105.5t112.5 76.5t142.5 29.5q81 0 133 -33.5t69 -89.5l-126 -78q-5 21 -16 35.5t-25.5 22.5t-31.5 11.5t-33 3.5q-42 0 -75 -17.5t-56 -45t-35 -61t-12 -65.5q0 -26 7.5 -48.5t21.5 -40 t35.5 -27.5t48.5 -10q33 0 71.5 16.5t62.5 56.5l102 -70q-20 -32 -51 -56t-67 -41t-74.5 -25.5t-74.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 619,
    d: "M118 563h225q63 0 109.5 -17.5t77 -48t45.5 -71.5t15 -88q0 -74 -28 -136t-77 -107t-116 -70t-146 -25h-225zM249 125q44 0 80 15.5t61 41.5t38.5 60.5t13.5 73.5q0 55 -32 88.5t-94 33.5h-82l-66 -313h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 519,
    d: "M118 563h415l-27 -125h-272l-19 -93h233l-24 -117h-234l-22 -103h279l-27 -125h-422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 494,
    d: "M118 563h407l-26 -125h-265l-22 -106h218l-25 -117h-218l-46 -215h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 688,
    d: "M302 -5q-64 0 -113.5 24.5t-84 65.5t-52.5 95t-18 114q0 77 31.5 152.5t87.5 135t132 96.5t165 37q87 0 145 -38.5t81 -108.5l-152 -102q-2 10 -8 27.5t-19 34t-34.5 29t-53.5 12.5q-47 0 -85.5 -25t-66 -64t-42.5 -87t-15 -95q0 -29 6.5 -57.5t20.5 -50.5t36 -35.5 t54 -13.5q25 0 48.5 8.5t44.5 22.5t38 32t28 38h-122l31 144h299l-17 -77q-14 -64 -48 -121t-82 -100t-108 -68t-127 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 599,
    d: "M388 49q-38 -28 -74.5 -40.5t-75.5 -12.5q-48 0 -88.5 19t-69 52t-44.5 76.5t-16 92.5q0 67 29 127.5t78 105.5t112 71.5t132 26.5q78 0 129.5 -33t68.5 -90l-124 -81q-10 35 -39 55.5t-67 20.5q-35 0 -66 -15.5t-54.5 -41.5t-37.5 -61.5t-14 -74.5q0 -54 29.5 -88 t80.5 -34q35 0 70.5 16.5t70.5 47.5l1 6h-113l21 103h233l-63 -297h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 643,
    d: "M118 563h143l-46 -212h233l45 212h144l-120 -563h-144l48 225h-232l-48 -225h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 267,
    d: "M118 563h143l-120 -563h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 434,
    d: "M78 -9q-76 0 -123 35l56 117q8 -8 33 -16t61 -8q31 0 51 9t33.5 28t22.5 49t18 72l61 286h144l-61 -286q-14 -65 -32.5 -117.5t-50.5 -90t-83 -58t-130 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 587,
    d: "M118 563h143l-52 -241l277 241h149l-277 -251l172 -312h-151l-123 231l-79 -63l-36 -168h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 463,
    d: "M118 563h143l-93 -438h250l-27 -125h-393z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 259,
    d: "M28 600l77 130h144l-125 -158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 736,
    d: "M118 563h156l91 -278l210 278h155l-120 -563h-143l67 314l-172 -224h-77l-77 224l-67 -314h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 652,
    d: "M118 563h112l207 -306l65 306h143l-119 -563h-115l-207 297l-63 -297h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 631,
    d: "M250 -5q-55 0 -98 20t-72.5 53t-45 76t-15.5 90q0 64 29 123.5t78 106t113 74.5t135 28q56 0 99 -20t72 -53.5t44 -76.5t15 -89q0 -63 -28.5 -122.5t-77.5 -106t-113 -75t-135 -28.5zM279 123q41 0 74 18t56 45.5t35.5 61.5t12.5 67q0 25 -7 47t-21 39t-35 27t-49 10 q-41 0 -74 -17.5t-56 -44.5t-35.5 -61t-12.5 -67q0 -25 6.5 -47.5t20.5 -40t35 -27.5t50 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 539,
    d: "M118 563h256q37 0 67 -14t50.5 -36.5t31.5 -52t11 -60.5q0 -41 -19 -81t-51 -72t-75.5 -51.5t-92.5 -19.5h-117l-38 -176h-143zM314 302q27 0 50 20.5t23 63.5q0 28 -14.5 40t-33.5 12h-105l-29 -136h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 633,
    d: "M402 32q-35 -17 -73.5 -26.5t-79.5 -9.5q-55 0 -98 19.5t-72.5 52.5t-45 76t-15.5 90q0 63 29 123t78 106.5t113.5 75t134.5 28.5q56 0 99 -20t72 -53.5t44 -77t15 -89.5q0 -65 -30 -125.5t-81 -107.5l69 -94h-135zM279 124q26 0 50 8l-72 99h135l24 -34q20 26 30 57 t10 61q0 25 -7 47.5t-20.5 39.5t-34.5 27t-49 10q-41 0 -74.5 -17.5t-56.5 -45t-35.5 -61.5t-12.5 -67q0 -25 7 -47.5t21 -39.5t35 -27t50 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 586,
    d: "M118 563h270q38 0 68 -14t50.5 -36.5t31.5 -52t11 -60.5q0 -59 -37 -110.5t-97 -81.5l94 -208h-164l-81 176h-85l-38 -176h-143zM329 302q13 0 26 6t23 17t16.5 26t6.5 33q0 25 -14 39.5t-34 14.5h-119l-29 -136h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 519,
    d: "M205 -7q-64 0 -127 18.5t-108 49.5l90 125q4 -8 19.5 -18.5t39 -21t53.5 -17.5t63 -7q35 0 51.5 11t16.5 29q0 12 -9.5 20t-26 14.5t-38 13t-46.5 14.5q-63 20 -93.5 50t-30.5 79q0 51 22 91t58 67.5t82.5 42t96.5 14.5q62 0 112.5 -20t84.5 -42l-87 -119q-4 5 -17 14 t-32.5 17.5t-43.5 15t-49 6.5q-70 0 -70 -42q0 -21 27.5 -32t75.5 -25q33 -9 60 -21t46 -28t29.5 -38t10.5 -52q0 -58 -23 -98t-60 -64.5t-83.5 -35.5t-93.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 536,
    d: "M226 438h-182l26 125h506l-27 -125h-179l-94 -438h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 629,
    d: "M250 -5q-57 0 -97.5 15t-66 42t-37 63t-11.5 78q0 39 9 81l62 289h143l-61 -289q-6 -27 -6 -52q0 -42 20.5 -70.5t70.5 -28.5q34 0 59.5 13t44 34t30 48t17.5 56l61 289h144l-61 -289q-12 -59 -38.5 -109.5t-67 -88.5t-94.5 -59.5t-121 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 576,
    d: "M52 563h152l61 -360l211 360h152l-347 -563h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1078,
    d: "M88 710h186l26 -463l233 463h178l37 -462l223 463h187l-361 -710h-170l-62 441l-248 -442h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 900,
    d: "M51 563h155l72 -390l75 124l-42 265h132l22 -176l97 176h133l-157 -265l24 -124l236 390h158l-360 -563h-119l-50 210l-137 -210h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 565,
    d: "M201 278l-146 285h156l88 -185l165 185h156l-267 -285l141 -278h-156l-82 177l-157 -177h-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 556,
    d: "M179 190l-130 373h155l73 -250l179 250h157l-291 -374l-41 -189h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 542,
    d: "M-10 107l376 331h-295l27 125h461l-22 -107l-363 -331h296l-27 -125h-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 620,
    d: "M197 -10q-43 0 -77.5 16t-58.5 44.5t-37 67.5t-13 86q0 67 23.5 127t63.5 105.5t91.5 72t107.5 26.5q52 0 88 -26t49 -70l17 79h160l-110 -518h-159l17 78q-32 -43 -71.5 -65.5t-90.5 -22.5zM268 125q33 0 61.5 19.5t54.5 53.5l23 109q-6 42 -30 67t-58 25 q-27 0 -52 -14.5t-44.5 -38.5t-31 -54.5t-11.5 -61.5q0 -45 23 -75t65 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 554,
    d: "M130 -10q-32 0 -58.5 10.5t-45 28.5t-28.5 43.5t-10 55.5q0 46 20.5 83.5t56 64.5t82 41.5t97.5 14.5q33 0 60 -6t44 -16l5 24q3 13 3 27q0 64 -80 64q-41 0 -81 -14.5t-87 -43.5l-25 100q56 33 113 50.5t119 17.5q99 0 150 -41t51 -119q0 -31 -7 -60l-67 -315h-154 l14 69q-34 -39 -77.5 -59t-94.5 -20zM202 105q21 0 44.5 8.5t42.5 24.5q11 9 19.5 18.5t10.5 19.5l10 50q-17 8 -37.5 12.5t-39.5 4.5q-20 0 -39.5 -6t-34.5 -16.5t-24 -26.5t-9 -35q0 -24 15.5 -39t41.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 937,
    d: "M230 -10q-54 0 -95 18t-68.5 48t-41.5 70t-14 85q0 60 23.5 118t67.5 104t107 74t141 28q46 0 74 -10t55 -29q-2 8 -3.5 22t-1.5 25q0 91 58.5 141t167.5 50q46 0 75.5 -9t47 -24t24 -35.5t6.5 -44.5q0 -23 -4.5 -47t-9.5 -49h100l-25 -121h-101l-46 -219q-2 -5 -2 -9v-7 q0 -33 34 -33q16 0 36 6t37 13v-127q-36 -14 -79.5 -26t-84.5 -12q-51 0 -84 22.5t-33 76.5q0 21 4 41l58 274h-63l26 121h63q11 53 11 83q0 29 -11.5 43t-40.5 14q-30 0 -50 -12.5t-31 -32t-15.5 -45t-4.5 -50.5q0 -18 2 -36.5t4.5 -36t5 -32.5t4.5 -24l-166 -47 q-18 50 -72 50q-27 0 -51.5 -13.5t-43.5 -36.5t-30.5 -54t-11.5 -66q0 -47 22 -75.5t58 -28.5q26 0 51 13.5t42 38.5l146 -48q-42 -63 -111 -101t-156 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 619,
    d: "M197 -10q-44 0 -78.5 16t-58.5 44.5t-36.5 67.5t-12.5 85q0 67 23.5 127t63 105.5t91 72.5t107.5 27q53 0 88.5 -26t49.5 -70l62 291h160l-155 -730h-159l16 76q-32 -42 -71 -64t-90 -22zM268 125q32 0 62.5 19.5t53.5 53.5l23 110q-5 41 -30.5 66t-57.5 25 q-27 0 -52 -14.5t-44.5 -38t-31 -54t-11.5 -62.5q0 -46 23.5 -75.5t64.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 587,
    d: "M529 248q0 -56 -25.5 -103t-67.5 -81.5t-97 -53.5t-113 -19q-44 0 -82 13.5t-66 38.5t-43.5 60t-15.5 78q0 38 12.5 69.5t31.5 56t42 42.5t44 30q-22 14 -34.5 42.5t-12.5 60.5q0 54 27 96.5t68.5 71.5t90 44.5t91.5 15.5q35 0 69.5 -11t62.5 -32.5t45 -53t17 -73.5 q0 -26 -9 -51t-23.5 -46t-33.5 -37.5t-38 -26.5q23 -18 41.5 -52t18.5 -79zM367 243q0 34 -20.5 52t-51.5 18q-21 0 -41 -8t-35 -22t-24 -33t-9 -42q0 -32 20.5 -52t50.5 -20q21 0 41 8.5t35 22.5t24.5 33.5t9.5 42.5zM264 488q0 -27 17.5 -41t38.5 -14q14 0 29.5 5.5t28 16 t21 25.5t8.5 35q0 24 -16 39t-42 15q-17 0 -32 -6t-27 -17t-19 -26t-7 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 552,
    d: "M190 -9q-74 0 -126 31t-72 87l110 99q20 -35 51.5 -56t67.5 -21q24 0 45 9t36.5 25t24.5 38t9 48q0 33 -17 53.5t-48 20.5q-24 0 -47.5 -12t-39.5 -34h-137q17 42 40 100.5t46.5 119t45.5 117t38 95.5h336l-31 -146h-220l-43 -121q6 7 22.5 12.5t42.5 5.5 q41 0 74.5 -13.5t57 -37.5t36 -58t12.5 -74q0 -62 -24.5 -115t-67.5 -91.5t-100 -60t-122 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 389,
    d: "M261 580q61 0 98 -32t37 -83q0 -37 -17 -68t-46.5 -54t-69 -36t-84.5 -13q-51 0 -89 19t-54 52l67 63q15 -20 40.5 -32t60.5 -12q39 0 68 18t29 56q0 28 -20 40.5t-41 12.5q-23 0 -49 -12t-41 -32h-80q12 31 27 65t30.5 68.5t30 68t25.5 62.5h238l-19 -93h-173l-34 -71 q10 5 26.5 9t39.5 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 416,
    d: "M143 -6q-33 0 -61 9t-48 24.5t-31.5 37t-11.5 46.5q0 24 8.5 42t22.5 32.5t32.5 25t38.5 19.5q-20 9 -33.5 25.5t-13.5 41.5q0 29 17.5 53.5t45.5 42t61 27.5t65 10q26 0 51.5 -7.5t45 -21t31.5 -33t12 -42.5q0 -35 -24 -58.5t-58 -37.5q26 -14 42 -35t16 -50 q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-77.5 -11.5zM163 87q17 0 34 4t30.5 11.5t21.5 18t8 22.5q0 21 -22 33t-52 12q-18 0 -35 -4t-30 -11.5t-21 -18t-8 -22.5q0 -20 22.5 -32.5t51.5 -12.5zM200 264q13 0 27 3t25 8.5t18.5 13.5t7.5 18q0 15 -18 24t-44 9 q-30 0 -54 -11t-24 -31q0 -16 19.5 -25t42.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 569,
    d: "M223 1l32 149h-260l30 143l399 418h110l-89 -418h84l-30 -143h-84l-32 -149h-160zM303 293l38 178l-157 -178h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 268,
    d: "M100 517h160l-155 -730h-160zM145 728h159l-30 -143h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 271,
    d: "M147 730h160l-155 -730h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 593,
    d: "M70 425q0 59 25.5 112t68.5 92.5t99 63t117 23.5q94 0 143.5 -63.5t49.5 -175.5q0 -101 -26.5 -190t-74.5 -155t-115 -104t-148 -38q-62 0 -110 27t-80 78l112 102q17 -32 45.5 -50t64.5 -18q54 0 93.5 42t58.5 119q-25 -28 -58 -43t-72 -15q-44 0 -79.5 14.5t-61 40.5 t-39 61.5t-13.5 76.5zM351 581q-23 0 -45 -11t-39.5 -29.5t-28.5 -43t-11 -50.5q0 -38 21 -63t56 -25q23 0 45 10.5t39.5 28t28 41t10.5 50.5q0 38 -21 65t-55 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 502,
    d: "M30 144h134l88 415q-10 -12 -31.5 -26.5t-46.5 -28t-51 -22.5t-45 -9l32 147q25 0 55.5 14.5t56.5 32t44 32.5t19 17h164l-122 -572h121l-31 -144h-417z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 300,
    d: "M297 389l-19 -92h-232l20 92h73l52 243q-7 -7 -19.5 -16t-26.5 -17t-29 -13.5t-26 -5.5l20 93q15 0 32.5 9t32.5 19.5t25.5 19.5t10.5 10h95l-74 -342h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 419,
    d: "M-35 0q9 42 21 73t31.5 54.5t48 42t68.5 34.5q27 10 52.5 20t46 21t33 25.5t12.5 35.5q0 20 -17 29t-47 9q-38 0 -71 -15t-55 -32l-44 69q12 12 31.5 24.5t46 22t58 16t67.5 6.5q68 0 103.5 -28.5t35.5 -81.5q0 -38 -13.5 -65.5t-35.5 -47t-49.5 -32t-55.5 -21.5 q-85 -26 -95 -68h202l-19 -91h-355v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 406,
    d: "M182 89h-206l20 91l288 251h63l-53 -251h60l-20 -91h-59l-19 -88h-92zM205 180l30 138l-152 -138h122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 399,
    d: "M120 -6q-60 0 -98 19t-46 57l64 70q1 -4 6.5 -12.5t17.5 -17.5t30 -15.5t44 -6.5q40 0 69.5 12t29.5 37q0 23 -34 33.5t-96 10.5h-24l18 85h23q60 0 99 11.5t39 39.5q0 9 -6 15t-15.5 9.5t-20.5 5.5t-21 2q-38 0 -65 -13t-51 -34l-42 76q15 14 35 25t43 18.5t48 11 t49 3.5q67 0 107.5 -29t40.5 -74q0 -41 -31 -68.5t-83 -35.5q40 -6 60.5 -32t20.5 -60q0 -38 -19 -65t-49 -44t-67.5 -25.5t-75.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 618,
    d: "M358 85q-34 -47 -80.5 -71t-101.5 -24q-39 0 -69.5 16t-51.5 44.5t-32.5 67t-11.5 83.5q0 69 25 130t66 106t95 71.5t112 26.5q57 0 92.5 -26t52.5 -70l18 86h140l-157 -739h-160zM267 125q31 0 60 19.5t55 51.5l24 111q-5 39 -29.5 65.5t-57.5 26.5q-27 0 -52.5 -14.5 t-45 -38t-31.5 -54t-12 -63.5q0 -45 23.5 -74.5t65.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 564,
    d: "M367 565h-276l31 146h529l-484 -710h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 388,
    d: "M316 638h-222l19 93h367l-334 -430h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 592,
    d: "M235 -10q-94 0 -144 63.5t-50 175.5q0 101 26.5 190t75 155t115.5 104t148 38q63 0 110.5 -27t79.5 -78l-112 -102q-17 32 -46 50t-64 18q-54 0 -94 -42t-58 -119q25 27 58 42t72 15q43 0 78.5 -14.5t61 -40t39 -61t13.5 -76.5q0 -59 -25.5 -112t-68.5 -92.5t-98.5 -63 t-116.5 -23.5zM264 125q22 0 44.5 11t40 29.5t28.5 43t11 50.5q0 38 -21 63t-56 25q-23 0 -45.5 -10.5t-39.5 -28.5t-27.5 -41.5t-10.5 -49.5q0 -38 21 -65t55 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 397,
    d: "M119 381h-75l30 144h75l36 167h165l-37 -167h115l-30 -144h-115l-81 -381h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 563,
    d: "M190 -9q-80 0 -128.5 32.5t-63.5 95.5l106 109q1 -9 6.5 -24.5t18 -30t33 -25t53.5 -10.5q23 0 44.5 6t38 17t26.5 27.5t10 36.5q0 42 -41.5 59t-123.5 17h-31l28 133h31q37 0 70.5 5.5t58.5 16.5t40 28.5t15 41.5q0 15 -5.5 25.5t-14.5 16.5t-19.5 8.5t-20.5 2.5 q-26 0 -49.5 -7.5t-42 -19t-32.5 -24.5t-21 -23l-77 118q22 23 52.5 41t64.5 30t69 18.5t68 6.5q46 0 83.5 -12.5t64 -34.5t41 -53t14.5 -67q0 -33 -12 -62t-33 -51.5t-50 -39t-64 -23.5q50 -9 76.5 -49.5t26.5 -97.5q0 -61 -29 -106t-74 -74t-100 -43.5t-107 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 399,
    d: "M182 289q-60 0 -98 19t-46 57l64 70q1 -4 7 -12.5t17.5 -17.5t29.5 -15.5t44 -6.5q40 0 70 12t30 37q0 24 -34.5 34t-96.5 10h-23l17 85h23q60 0 99 12t39 39q0 9 -6 15.5t-15.5 10t-20.5 5.5t-21 2q-37 0 -64.5 -13t-51.5 -34l-42 75q15 14 35 25t43 18.5t48.5 11 t49.5 3.5q33 0 60 -8t46.5 -21.5t30 -32t10.5 -40.5q0 -42 -31 -69.5t-83 -35.5q40 -6 60.5 -32t20.5 -60q0 -38 -19 -65t-49 -44t-67.5 -25.5t-75.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 600,
    d: "M-23 0q15 69 32 121t44 91t66 68.5t98 55.5q37 16 72 32.5t62 36.5t43 46.5t16 62.5q0 30 -17 46t-45 16q-22 0 -44.5 -7t-44 -18.5t-41 -25.5t-35.5 -28l-77 106q21 19 51.5 39t68.5 37t82.5 28t92.5 11q97 0 146 -46.5t49 -126.5q0 -53 -13 -91.5t-38.5 -69 t-62.5 -55.5t-84 -50q-30 -16 -56.5 -31t-47 -30.5t-34.5 -33.5t-18 -40h274l-31 -144h-508v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 415,
    d: "M28 296q9 42 21 73t31.5 54.5t48 42t68.5 34.5q27 10 53 20t46 21t32.5 25.5t12.5 35.5q0 20 -17 29t-47 9q-38 0 -71 -14.5t-55 -31.5l-43 68q12 12 31.5 24.5t45 22t57 16t67.5 6.5q69 0 104.5 -28.5t35.5 -81.5q0 -38 -13.5 -65.5t-35.5 -47t-49.5 -32.5t-55.5 -21 q-86 -26 -95 -68h187l-20 -91h-339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    d: "M149 -10q-69 0 -101 32t-32 94q0 32 9 73l72 336h160l-64 -301q-2 -11 -3.5 -21t-1.5 -19q0 -28 12.5 -43.5t40.5 -15.5q25 0 55 18t61 58l68 324h160l-112 -525h-153l17 81q-36 -48 -86.5 -69.5t-101.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 849,
    d: "M49 525h165l28 -335l152 335h150l11 -335l169 335h165l-281 -525h-182l-10 275l-135 -275h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 521,
    d: "M-4 -213q24 38 56.5 94.5t68.5 118.5l-76 525h171l21 -388l176 388h150l-381 -738h-186v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 682,
    d: "M275 -10q-62 0 -106 26t-72.5 67.5t-42 93t-13.5 103.5q0 49 14 100t39 98.5t60.5 90t78.5 74t92 49.5t102 18q62 0 106 -26.5t72.5 -68.5t42 -94t13.5 -103q0 -49 -14 -100t-39 -98.5t-60 -89t-78 -73t-92.5 -49.5t-102.5 -18zM306 136q44 0 79 28t59 69.5t37 89.5 t13 87q0 29 -5.5 56.5t-17 49.5t-30 35t-44.5 13q-45 0 -80.5 -30.5t-59.5 -75t-36.5 -94.5t-12.5 -90q0 -27 5.5 -52t17 -44t30 -30.5t45.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 239,
    d: "M4 -204l29 137h144l-29 -137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 482,
    d: "M177 -6q-45 0 -77.5 16.5t-53 42.5t-30.5 58t-10 64q0 44 20.5 89.5t56 82t83.5 60t103 23.5q45 0 77 -16.5t52.5 -43t30 -59t9.5 -64.5q0 -44 -20 -88.5t-55.5 -81.5t-83 -60t-102.5 -23zM196 87q35 0 62 15t46 37t28.5 48t9.5 48q0 19 -5.5 37t-17 32.5t-29 23.5 t-41.5 9q-35 0 -62.5 -15t-46.5 -37t-28.5 -48.5t-9.5 -48.5q0 -18 5.5 -36.5t17 -32.5t29 -23t42.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 339,
    d: "M2 91h96l51 243q-8 -7 -22.5 -16t-32 -17t-35.5 -13.5t-32 -5.5l19 93q18 0 39.5 9t40.5 19.5t31.5 20t12.5 10.5h94l-73 -343h87l-18 -91h-277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 389,
    d: "M115 -6q-51 0 -89.5 19t-54.5 51l68 64q14 -20 40 -32t61 -12q19 0 36.5 4.5t30.5 13.5t21 23t8 33q0 28 -19.5 40.5t-40.5 12.5q-23 0 -49.5 -12t-40.5 -32h-80q12 31 27 65t30 68.5t29.5 68t25.5 62.5h239l-20 -93h-172l-34 -71q9 5 25.5 9t40.5 4q61 0 97.5 -32 t36.5 -83q0 -37 -17 -68t-46.5 -54t-68.5 -36t-84 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 421,
    d: "M148 -6q-68 0 -105 40.5t-37 113.5q0 61 18 113.5t51 91t78.5 60t101.5 21.5q44 0 79 -16t55 -46l-67 -65q-11 18 -35.5 28t-54.5 10q-46 0 -78 -23t-43 -66q19 16 48.5 23.5t55.5 7.5q69 0 108.5 -34.5t39.5 -85.5q0 -35 -17.5 -66.5t-47 -55t-68.5 -37.5t-82 -14z M168 80q20 0 39 6t33.5 15.5t23.5 22.5t9 28q0 23 -22 38.5t-56 15.5q-21 0 -40 -5.5t-33.5 -15t-23 -22t-8.5 -27.5q0 -23 22.5 -39.5t55.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 389,
    d: "M252 338h-221l20 93h366l-334 -430h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 421,
    d: "M130 -6q-45 0 -80.5 16t-55.5 46l67 65q12 -18 36.5 -28.5t54.5 -10.5q45 0 77.5 23.5t43.5 66.5q-18 -16 -48.5 -24t-57.5 -8q-67 0 -106.5 34.5t-39.5 85.5q0 36 17.5 67.5t47 55t68 37.5t81.5 14q69 0 106 -41t37 -113q0 -62 -18 -114t-51 -90.5t-78.5 -60 t-100.5 -21.5zM189 222q20 0 39 5.5t33.5 15t23 22t8.5 26.5q0 23 -22 40t-55 17q-20 0 -39 -6t-33.5 -16t-23.5 -23t-9 -27q0 -23 22.5 -38.5t55.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 482,
    d: "M241 294q-45 0 -77.5 16.5t-53 42.5t-30.5 58t-10 64q0 44 20.5 89.5t56 82t83.5 60t103 23.5q45 0 77 -16.5t52.5 -43t30 -59t9.5 -64.5q0 -44 -20 -88.5t-55.5 -81.5t-83 -60t-102.5 -23zM167 488q0 -18 5 -36.5t16.5 -32.5t29 -23t42.5 -9q35 0 62 15t46 37t28.5 48 t9.5 48q0 19 -5.5 37t-16.5 32.5t-29 23.5t-42 9q-35 0 -62.5 -15t-46 -37t-28 -48.5t-9.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 406,
    d: "M228 301l18 88h-206l19 91l289 251h63l-53 -251h60l-20 -91h-60l-19 -88h-91zM147 480h122l30 138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 421,
    d: "M426 463q0 -35 -17.5 -66.5t-47 -55t-68.5 -37.5t-82 -14q-68 0 -105 40.5t-37 113.5q0 61 18 113.5t51 91t78.5 60t101.5 21.5q44 0 79.5 -15.5t55.5 -46.5l-67 -65q-12 18 -36.5 28t-54.5 10q-46 0 -78 -23t-43 -66q19 16 48.5 23.5t55.5 7.5q69 0 108.5 -34.5 t39.5 -85.5zM231 376q20 0 39 6t33.5 16t23.5 23t9 27q0 23 -22 38.5t-56 15.5q-21 0 -40 -5.5t-33.5 -15t-23 -22t-8.5 -26.5q0 -23 22.5 -40t55.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 416,
    d: "M415 445q0 -32 -17.5 -59.5t-46.5 -48t-66.5 -32t-77.5 -11.5q-33 0 -60.5 9t-48 24.5t-31.5 37t-11 46.5q0 24 8 42t22 32.5t32.5 25t38.5 19.5q-20 9 -33 25.5t-13 41.5q0 29 17.5 53.5t45 42t60.5 27.5t65 10q26 0 51.5 -7.5t45 -21t31.5 -33t12 -42.5 q0 -35 -24 -58.5t-58 -37.5q26 -14 42 -35t16 -50zM322 443q0 21 -22.5 33t-52.5 12q-18 0 -35 -4t-30 -11.5t-21 -18t-8 -22.5q0 -20 23 -32.5t52 -12.5q17 0 34 4t30.5 11.5t21.5 18t8 22.5zM202 598q0 -16 19.5 -25t42.5 -9q13 0 27 3t25 8.5t18.5 13.5t7.5 18 q0 15 -18 24t-44 9q-30 0 -54 -11t-24 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 421,
    d: "M84 557q0 35 17.5 66.5t47 55t68 37.5t81.5 14q69 0 106 -41t37 -113q0 -62 -18 -114t-51 -90.5t-78.5 -60t-100.5 -21.5q-45 0 -80.5 16t-55.5 47l67 64q12 -18 36.5 -28.5t54.5 -10.5q46 0 78 24t43 66q-18 -15 -48.5 -23t-57.5 -8q-68 0 -107 34t-39 86zM279 644 q-20 0 -39 -6t-33.5 -16t-23.5 -23t-9 -27q0 -23 22.5 -38.5t55.5 -15.5q20 0 39 5.5t33.5 15t23.5 22t9 26.5q0 23 -22.5 40t-55.5 17z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xD7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xD7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "=",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0177",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0142",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0141",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0110",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "q.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "d.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "a.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xE1",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "g",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "d",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "a",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "/",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "four.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "six",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "eth",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "ae,aeacute,a.alt2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayExtraBoldItalic);
export default __webpack_public_path__ + "static/media/Raleway-ExtraBoldItalic.ca729eb7961c053be838a4464e703053.svg";
export { ForwardRef as ReactComponent };